import * as React from 'react';
import React__default, { useState, useEffect, forwardRef, useRef, useCallback, useMemo, createRef } from 'react';
import cn from 'classnames';
import Truncate from 'react-dotdotdot';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import InputMask from 'react-input-mask';
import dayjs from 'dayjs';
import ReactDOM from 'react-dom';
import { motion } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import SimpleBar from 'simplebar-react';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import Slider from 'react-slick';
import Tippy from '@tippyjs/react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var _path$1a;

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var SvgAnimatedSpinner = function SvgAnimatedSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  }))));
};

var _path$19;

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 8.707a1 1 0 0 0 0-1.414L7.343.929A1 1 0 0 0 5.93 2.343L11.586 8l-5.657 5.657a1 1 0 1 0 1.414 1.414l6.364-6.364ZM0 9h13V7H0v2Z",
    fill: "currentColor"
  })));
};

var _path$18;

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var SvgArrowAccordion = function SvgArrowAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.707 8.707a1 1 0 0 1-1.414 0L.929 2.343A1 1 0 0 1 2.343.93L8 6.586 13.657.929a1 1 0 1 1 1.414 1.414L8.707 8.707ZM9 7v1H7V7h2Z",
    fill: "currentColor"
  })));
};

var _path$17;

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var SvgArrowAccordionUp = function SvgArrowAccordionUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.022 1.963 4.845 4.668a.552.552 0 0 0 .766-.795L7.716 1.099a1 1 0 0 0-1.387 0L1.412 5.836a.552.552 0 0 0 .766.795l4.844-4.668Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};

var _path$16;

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var SvgArrowButton = function SvgArrowButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.033 8.869 6.29-6.527A.744.744 0 0 0 8.252 1.31L1.636 8.175a1 1 0 0 0 0 1.388l6.616 6.865a.744.744 0 1 0 1.07-1.032L3.034 8.869Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};

var _path$15;

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var SvgArrowForwardIos = function SvgArrowForwardIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 6 5.5L1 12",
    stroke: "currentColor",
    strokeWidth: 1.568,
    strokeMiterlimit: 10
  })));
};

var _path$14, _path2$o;

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var SvgArrowInCircle = function SvgArrowInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.265 31.348a1.541 1.541 0 0 1 .465-1.105 1.59 1.59 0 0 1 1.122-.457h22.405a1.5 1.5 0 0 1 .844.316c.09.058.17.131.237.216.248.274.386.629.388.997v21.972a1.54 1.54 0 0 1-.4 1.207 1.587 1.587 0 0 1-1.179.516 1.608 1.608 0 0 1-1.178-.516 1.558 1.558 0 0 1-.4-1.207V35.005L32.966 54.383a1.554 1.554 0 0 1-1.114.465 1.54 1.54 0 0 1-1.114-.465 1.527 1.527 0 0 1-.471-1.097 1.509 1.509 0 0 1 .47-1.097L50.34 32.894H31.768a1.598 1.598 0 0 1-1.063-.48 1.55 1.55 0 0 1-.44-1.066Z",
    fill: "currentColor"
  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
    d: "M84.949 42.398c0 22.938-18.777 41.54-41.95 41.54-23.172 0-41.948-18.602-41.948-41.54S19.827.858 43 .858c23.172 0 41.949 18.602 41.949 41.54Z",
    stroke: "currentColor"
  })));
};

var _path$13;

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var SvgArrowLong = function SvgArrowLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5a1.5 1.5 0 0 0 0 3v-3Zm61.06 2.56a1.5 1.5 0 0 0 0-2.12l-9.545-9.547a1.5 1.5 0 1 0-2.122 2.122L59.88 12l-8.486 8.485a1.5 1.5 0 1 0 2.122 2.122l9.546-9.546ZM2 13.5h60v-3H2v3Z",
    fill: "currentColor"
  })));
};

var _path$12;

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var SvgArrowProfile = function SvgArrowProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    d: "m.25 1.71 3.963 4.625a1.036 1.036 0 0 0 1.574 0L9.75 1.71A1.036 1.036 0 0 0 8.964 0H1.036A1.036 1.036 0 0 0 .25 1.71Z",
    fill: "currentColor"
  })));
};

var _path$11, _path2$n;

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var SvgArrowQuizSlider = function SvgArrowQuizSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5C0 10.074 10.074 0 22.5 0S45 10.074 45 22.5 34.926 45 22.5 45 0 34.926 0 22.5Z",
    fill: "currentColor"
  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.787 22.115-6.29-6.527a.744.744 0 0 1 1.071-1.032l6.616 6.865a1 1 0 0 1 0 1.388l-6.616 6.865a.744.744 0 0 1-1.071-1.032l6.29-6.527Z",
    fill: "#fff",
    stroke: "#fff"
  })));
};

var _path$10;

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    d: "m.645.357 5.718 5.644-5.718 5.644",
    stroke: "currentColor",
    strokeWidth: 1.568,
    strokeMiterlimit: 10
  })));
};

var _g$4, _defs$4;

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var SvgArrowScrollUp = function SvgArrowScrollUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-scroll-up_svg__a)",
    stroke: "currentColor",
    strokeWidth: 1.568,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.357 6.37 6 .66l5.644 5.708M6 14V4.446"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-scroll-up_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 7 7)",
    d: "M0 0h14v12H0z"
  })))));
};

var _path$$;

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M2 18 21 1m0 0v17m0-17H2.002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
};

var _path$_;

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var SvgArrowBottomRight = function SvgArrowBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.761a1.232 1.232 0 0 0 .77 1.145c.15.062.313.094.476.094H18.84c.242-.013.473-.1.663-.25a.753.753 0 0 0 .185-.172c.195-.218.304-.499.305-.79V1.366a1.233 1.233 0 0 0-.733-1.26 1.253 1.253 0 0 0-1.432.303 1.238 1.238 0 0 0-.314.957v14.496L2.121.497a1.22 1.22 0 0 0-.875-.37 1.2 1.2 0 0 0-.875.37 1.212 1.212 0 0 0-.273 1.341c.063.15.156.285.273.398l15.393 15.3H1.18a1.25 1.25 0 0 0-.834.38c-.22.228-.343.53-.346.845Z",
    fill: "#000"
  })));
};

var _g$3, _defs$3;

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#back_svg__a)",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.274 16.025 1 8.5 8.274.975",
    strokeWidth: 1.568
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5H6.105",
    strokeWidth: 1.5
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "back_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-180 9 8.25)",
    d: "M0 0h18v16H0z"
  })))));
};

var _path$Z;

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    d: "M12.143 1H2.857C1.836 1 1 1.8 1 2.778v12.73a1 1 0 0 0 1.38.926l5.12-2.1 5.12 2.1a1 1 0 0 0 1.38-.925V2.778C14 1.8 13.164 1 12.143 1Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
};

var _path$Y;

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.98H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2ZM23 5.313H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2ZM23 20.646H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  })));
};

var _path$X;

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var SvgBurgerLower = function SvgBurgerLower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    d: "M20.077 8.758H1.312c-.725 0-1.312.447-1.312 1 0 .552.587 1 1.312 1h18.765c.725 0 1.312-.448 1.312-1 0-.553-.587-1-1.312-1ZM20.077.133H1.312C.587.133 0 .58 0 1.133c0 .552.587 1 1.312 1h18.765c.725 0 1.312-.448 1.312-1 0-.553-.587-1-1.312-1Z",
    fill: "currentColor"
  })));
};

var _path$W, _path2$m;

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    d: "M17.297 2.115h-3.463v-.709a.703.703 0 0 0-1.406 0v.71H5.572v-.71a.703.703 0 1 0-1.406 0v.71H.703A.703.703 0 0 0 0 2.817v13.776c0 .388.315.703.703.703h16.594a.703.703 0 0 0 .703-.703V2.818a.703.703 0 0 0-.703-.703Zm-.703 13.776H1.406V3.52h2.76v.71a.703.703 0 1 0 1.406 0v-.71h6.856v.71a.703.703 0 1 0 1.406 0v-.71h2.76v12.37Z",
    fill: "#181818"
  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.21a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9ZM9 13.34a.95.95 0 1 0 0-1.898.95.95 0 0 0 0 1.899ZM4.869 9.21a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9ZM13.131 9.21a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9ZM4.869 13.34a.95.95 0 1 0 0-1.898.95.95 0 0 0 0 1.899ZM13.131 13.34a.95.95 0 1 0 0-1.898.95.95 0 0 0 0 1.899Z",
    fill: "#181818"
  })));
};

var _path$V, _path2$l;

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var SvgCalendar2 = function SvgCalendar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.385 1.23V.924a.923.923 0 0 1 1.846 0v.308h.923A5.845 5.845 0 0 1 24 7.077v11.077A5.846 5.846 0 0 1 18.154 24H5.846A5.846 5.846 0 0 1 0 18.154V7.077A5.845 5.845 0 0 1 5.846 1.23h.923V.923a.923.923 0 0 1 1.846 0v.308h6.77Zm6.769 8.616H1.846v8.308a3.996 3.996 0 0 0 4 4h12.308a3.996 3.996 0 0 0 4-4V9.846ZM6.769 3.076h-.923c-1.06 0-2.079.422-2.828 1.173a3.996 3.996 0 0 0-1.172 2.828V8h20.308v-.923a3.996 3.996 0 0 0-4-4h-.923v.308a.923.923 0 0 1-1.846 0v-.308h-6.77v.308a.923.923 0 0 1-1.846 0v-.308Z",
    fill: "currentColor"
  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
    d: "M5.539 14.48a.923.923 0 1 0 0-1.845.923.923 0 0 0 0 1.846ZM5.539 18.75a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM9.865 14.48a.923.923 0 1 0 0-1.845.923.923 0 0 0 0 1.846ZM9.865 18.75a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM14.135 14.48a.923.923 0 1 0 0-1.845.923.923 0 0 0 0 1.846ZM14.135 18.75a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM18.462 14.48a.923.923 0 1 0 0-1.845.923.923 0 0 0 0 1.846ZM18.462 18.75a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846Z",
    fill: "currentColor"
  })));
};

var _path$U, _path2$k;

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var SvgClip = function SvgClip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "m10.076 6.741-3.333 3.334a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0l3.333-3.333a.837.837 0 0 0-1.183-1.184Z",
    fill: "currentColor"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    d: "m9.232 13.5-1.067 1.058a3.5 3.5 0 0 1-4.65.334A3.333 3.333 0 0 1 3.29 9.95l1.183-1.192a.833.833 0 0 0-.27-1.365.833.833 0 0 0-.913.182L2.232 8.642a5.125 5.125 0 0 0-.559 6.725 5.05 5.05 0 0 0 7.559.5l1.183-1.184A.837.837 0 0 0 9.232 13.5Zm6.15-11.817a5.15 5.15 0 0 0-6.775.567l-.9.917a.908.908 0 0 0-.142 1.341.833.833 0 0 0 1.183 0l1.084-1.091a3.475 3.475 0 0 1 4.641-.334 3.333 3.333 0 0 1 .225 4.959l-1.183 1.191a.833.833 0 0 0 0 1.184.833.833 0 0 0 1.183 0l1.184-1.184a5.05 5.05 0 0 0-.5-7.55Z",
    fill: "currentColor"
  })));
};

var _path$T;

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7.3c-.4-.4-1-.4-1.4 0L3 3.6 1.7 2.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4Z",
    fill: "currentColor"
  })));
};

var _path$S;

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var SvgCheckMarkCircle = function SvgCheckMarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    d: "M13 .166c1.766 0 3.451.343 5.055 1.03 1.603.686 2.985 1.609 4.146 2.77 1.16 1.16 2.083 2.542 2.77 4.145A12.712 12.712 0 0 1 26 13.166c0 1.766-.343 3.451-1.03 5.055-.686 1.603-1.609 2.985-2.77 4.145-1.16 1.161-2.542 2.084-4.145 2.77A12.714 12.714 0 0 1 13 26.167c-1.766 0-3.451-.343-5.055-1.03-1.603-.686-2.985-1.609-4.145-2.77-1.161-1.16-2.084-2.542-2.77-4.145A12.714 12.714 0 0 1 0 13.166C0 11.4.343 9.715 1.03 8.111c.686-1.603 1.609-2.985 2.77-4.145 1.16-1.161 2.542-2.084 4.145-2.77A12.713 12.713 0 0 1 13 .165Zm0 2.364c-1.44 0-2.818.281-4.132.845-1.314.563-2.445 1.319-3.393 2.266-.947.948-1.703 2.08-2.266 3.393a10.38 10.38 0 0 0-.845 4.132c0 1.44.281 2.817.845 4.132.563 1.314 1.319 2.445 2.266 3.393.948.948 2.08 1.703 3.393 2.266a10.38 10.38 0 0 0 4.132.845c1.44 0 2.818-.281 4.132-.845 1.314-.563 2.445-1.319 3.393-2.266.948-.948 1.703-2.08 2.266-3.393a10.38 10.38 0 0 0 .845-4.132c0-1.44-.281-2.817-.845-4.132-.563-1.314-1.319-2.445-2.266-3.393-.948-.947-2.08-1.703-3.393-2.266A10.379 10.379 0 0 0 13 2.53Zm3.98 7.081c.325 0 .604.116.835.346.23.231.346.51.346.836 0 .326-.117.606-.351.84l-5.013 5.014a1.13 1.13 0 0 1-.831.341c-.333 0-.613-.114-.84-.341l-2.512-2.502a1.142 1.142 0 0 1-.341-.84c0-.327.115-.605.346-.836.23-.231.51-.346.836-.346.326 0 .606.117.84.35l1.67 1.672 4.174-4.183c.234-.234.514-.35.84-.35Z",
    fill: "currentColor"
  })));
};

var _path$R, _path2$j;

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    d: "m16.276 14.12-3.346-2.51V6.496a.929.929 0 1 0-1.86 0v5.577c0 .293.138.57.372.744l3.718 2.788a.925.925 0 0 0 .557.186.922.922 0 0 0 .745-.373.928.928 0 0 0-.186-1.3Z",
    fill: "currentColor"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm0 22.141c-5.591 0-10.141-4.55-10.141-10.141S6.409 1.859 12 1.859c5.592 0 10.141 4.55 10.141 10.141S17.591 22.141 12 22.141Z",
    fill: "currentColor"
  })));
};

var _path$Q, _path2$i;

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "M15.923 17.308.693 2.077A.98.98 0 0 1 2.076.692l15.23 15.231a.98.98 0 0 1-1.384 1.385Z",
    fill: "currentColor"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    d: "M17.308 2.077 2.077 17.307a.98.98 0 0 1-1.385-1.384L15.923.693a.98.98 0 0 1 1.385 1.384Z",
    fill: "currentColor"
  })));
};

var _path$P, _path2$h, _path3$2;

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M13 26a13 13 0 1 1 0-26 13 13 0 0 1 0 26Zm0-24a11 11 0 1 0 0 22 11 11 0 0 0 0-22Z",
    fill: "currentColor"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    d: "M8.76 18.24a1.002 1.002 0 0 1-.71-.29 1 1 0 0 1 0-1.41l8.49-8.49A1.015 1.015 0 1 1 18 9.46L9.46 18a1 1 0 0 1-.7.24Z",
    fill: "currentColor"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 18.24a1 1 0 0 1-.7-.29L8.05 9.46a1 1 0 0 1 1.41-1.411L18 16.54A.998.998 0 0 1 18 18a1 1 0 0 1-.76.24Z",
    fill: "currentColor"
  })));
};

var _path$O;

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var SvgCloseCircleBg = function SvgCloseCircleBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 .667a8.333 8.333 0 1 1 0 16.666A8.333 8.333 0 0 1 9 .667ZM10.177 9l2.357-2.357a.833.833 0 0 0-1.179-1.179L9 7.821 6.642 5.464a.833.833 0 1 0-1.178 1.179L7.82 9l-2.357 2.357a.833.833 0 1 0 1.178 1.179L9 10.178l2.357 2.357a.833.833 0 0 0 1.179-1.179L10.178 9Z",
    fill: "currentColor"
  })));
};

var _path$N, _path2$g;

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.765 10.015a4.75 4.75 0 0 0-4.75-4.75h-5a4.75 4.75 0 0 0-4.75 4.75v5a4.75 4.75 0 0 0 4.75 4.75h5a4.75 4.75 0 0 0 4.75-4.75v-5Zm-1.5 0v5a3.247 3.247 0 0 1-3.25 3.25h-5a3.247 3.247 0 0 1-3.25-3.25v-5a3.247 3.247 0 0 1 3.25-3.25h5a3.247 3.247 0 0 1 3.25 3.25Z",
    fill: "currentColor"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.404 3.219A4.75 4.75 0 0 0 10 .25H5A4.75 4.75 0 0 0 .25 5v5a4.75 4.75 0 0 0 2.969 4.404.75.75 0 1 0 .562-1.39A3.251 3.251 0 0 1 1.75 10V5A3.247 3.247 0 0 1 5 1.75h5c1.364 0 2.532.84 3.014 2.031a.75.75 0 1 0 1.39-.562Z",
    fill: "currentColor"
  })));
};

var _path$M, _path2$f;

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var SvgDesk = function SvgDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    d: "M17.688 15.806 12 19.006l-5.688-3.2v-3.38l-1.625-.903v5.233L12 20.87l7.313-4.114v-5.233l-1.625.903v3.38Z",
    fill: "currentColor"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    d: "M12 .335.625 6.233V7.64L12 13.961l9.75-5.417v4.487h1.625V6.233L12 .335Zm8.125 7.253L18.5 8.49 12 12.1l-6.5-3.61-1.625-.903-1.126-.626L12 2.165l9.251 4.797-1.126.626Z",
    fill: "currentColor"
  })));
};

var _path$L;

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var SvgDocFile = function SvgDocFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    viewBox: "0 0 14 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M9.226 4.262V0H.608A.615.615 0 0 0 0 .622v16.756c0 .343.272.622.608.622h12.784a.615.615 0 0 0 .608-.622V4.884H9.834a.615.615 0 0 1-.608-.622Z"
  })));
};

var _path$K, _path2$e;

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var SvgDocWithCross = function SvgDocWithCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    viewBox: "0 0 50 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M34.561 27.198a3.497 3.497 0 0 0-2.477-1.022c-.937 0-1.817.36-2.477 1.023L25 31.774 20.393 27.2a3.497 3.497 0 0 0-2.477-1.023c-.937 0-1.817.36-2.477 1.023a3.461 3.461 0 0 0 0 4.922l4.606 4.576-4.606 4.577a3.474 3.474 0 0 0 0 4.922 3.497 3.497 0 0 0 2.477 1.022c.937 0 1.817-.36 2.477-1.022L25 41.619l4.607 4.577a3.497 3.497 0 0 0 2.477 1.022c.937 0 1.817-.36 2.477-1.022a3.474 3.474 0 0 0 0-4.922l-4.607-4.57 4.607-4.576a3.47 3.47 0 0 0 0-4.93Zm-1.334 3.597-5.281 5.246a.937.937 0 0 0-.277.663c0 .247.1.487.277.663l5.28 5.247a1.589 1.589 0 0 1 0 2.263c-.61.607-1.667.607-2.278 0l-5.28-5.246a.95.95 0 0 0-1.335 0l-5.281 5.246c-.61.607-1.668.607-2.279 0a1.589 1.589 0 0 1 0-2.263l5.281-5.247a.937.937 0 0 0 .277-.663c0-.247-.1-.486-.277-.663l-5.28-5.246a1.589 1.589 0 0 1 0-2.264c.61-.606 1.667-.606 2.278 0l5.28 5.247a.956.956 0 0 0 1.342 0l5.281-5.247c.61-.606 1.668-.606 2.279 0a1.608 1.608 0 0 1-.007 2.264Z",
    fill: "currentColor"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    d: "M50 15.253a.94.94 0 0 0-.362-.74L35.314.274a1.035 1.035 0 0 0-.256-.176.866.866 0 0 0-.227-.078h-.007A.779.779 0 0 0 34.639 0H3.783C1.696 0 0 1.685 0 3.759v55.49C0 61.322 1.696 63 3.783 63h42.434C48.304 63 50 61.315 50 59.248V15.254ZM35.59 3.216l11.173 11.099H35.591v-11.1Zm10.627 57.901H3.783a1.881 1.881 0 0 1-1.888-1.876V3.76c0-1.037.845-1.876 1.888-1.876h29.92v13.37a.94.94 0 0 0 .944.938h13.458v43.05a1.89 1.89 0 0 1-1.888 1.876Z",
    fill: "currentColor"
  })));
};

var _path$J;

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    d: "M52.017 22H37.35V0h-22v22H.684L26.35 47.667 52.017 22ZM.684 55v7.333h51.333V55H.684Z",
    fill: "currentColor"
  })));
};

var _path$I;

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "m12.405 4.027-.884.854-2.21-2.137.884-.853a.5.5 0 0 1 .674 0l1.536 1.486a.45.45 0 0 1 0 .65Zm-7.387 7.141-2.21-2.137 5.714-5.525 2.21 2.137-5.714 5.525Zm-2.721-1.107 1.654 1.6-2.304.627.65-2.227Zm10.897-7.446L11.657 1.13c-.3-.29-1.383-.838-2.248 0L1.623 8.652a.514.514 0 0 0-.142.234L.308 12.92a.535.535 0 0 0 .141.527c.142.14.426.164.546.137l4.176-1.135a.541.541 0 0 0 .242-.137l7.78-7.523c.62-.598.62-1.573 0-2.174Z",
    fill: "currentColor"
  })));
};

var _path$H;

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.516v12.988h20V3.516H0Zm18.291 1.171L10 11.19 1.709 4.688h16.582ZM1.171 15.332V5.756L10 12.679l8.828-6.923v9.576H1.172Z",
    fill: "currentColor"
  })));
};

var _path$G, _path2$d;

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M17.886 8.65C17.725 8.43 13.893 3.264 9 3.264 4.106 3.264.275 8.43.114 8.65a.594.594 0 0 0 0 .7c.16.22 3.992 5.386 8.886 5.386 4.893 0 8.725-5.166 8.886-5.386a.593.593 0 0 0 0-.7ZM9 13.55c-3.605 0-6.727-3.43-7.65-4.55C2.271 7.878 5.387 4.45 9 4.45c3.604 0 6.726 3.429 7.65 4.55-.922 1.122-4.038 4.55-7.65 4.55Z",
    fill: "#666C77"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.44A3.565 3.565 0 0 0 5.44 9 3.565 3.565 0 0 0 9 12.56 3.565 3.565 0 0 0 12.56 9 3.565 3.565 0 0 0 9 5.44Zm0 5.933A2.376 2.376 0 0 1 6.626 9 2.376 2.376 0 0 1 9 6.626 2.376 2.376 0 0 1 11.373 9 2.376 2.376 0 0 1 9 11.373Z",
    fill: "#666C77"
  })));
};

var _path$F, _path2$c;

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var SvgEyeClose = function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M15.94 7.477C15.816 7.294 12.788 3 8 3 3.893 3 .233 7.27.08 7.451a.333.333 0 0 0 0 .43c.154.183 3.814 4.452 7.921 4.452s7.767-4.27 7.921-4.451a.334.334 0 0 0 .02-.405ZM8 10.333a2.67 2.67 0 0 1-2.666-2.666A2.67 2.67 0 0 1 8 5a2.67 2.67 0 0 1 2.667 2.667A2.67 2.67 0 0 1 8 10.333Z",
    fill: "currentColor"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m1.354.646 14 14"
  })));
};

var _path$E;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.052 14.85V8.152h2.296l.344-2.665h-2.64V3.786c0-.771.215-1.297 1.321-1.297h1.411V.104A18.804 18.804 0 0 0 5.728 0C3.694 0 2.3 1.241 2.3 3.523v1.964H0v2.665h2.3v6.698h2.752Z",
    fill: "currentColor"
  })));
};

var _path$D, _path2$b;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    d: "M30.68 0H2.597v40h33.804V5.55L30.679 0Zm3.06 37.336H5.26V2.663h24.046V6.89h4.432v30.447Z",
    fill: "currentColor"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    d: "M10.72 23.21h1.365v-.546c1.59 0 2.485-.938 2.485-2.198 0-1.246-.91-2.142-2.485-2.142v-.434H10.72v.434c-1.575 0-2.485.896-2.485 2.142 0 1.26.896 2.198 2.485 2.198v.546Zm0-1.75c-.644 0-1.092-.343-1.092-.973 0-.609.448-.959 1.092-.959v1.932Zm1.365 0v-1.932c.644 0 1.092.35 1.092.959 0 .63-.448.973-1.092.973ZM14.794 23h1.428l.35-.875h1.89l.357.875h1.456l-2.086-4.935H16.88L14.794 23Zm2.177-1.932.553-1.393.546 1.393h-1.099ZM20.75 23h1.268l1.897-2.758V23h1.344v-4.9h-1.267l-1.897 2.758V18.1H20.75V23Zm2.297-5.215c.679 0 1.134-.392 1.239-1.071l-.742-.133c-.091.252-.231.42-.497.42-.26 0-.4-.168-.49-.42l-.742.133c.105.679.56 1.071 1.232 1.071ZM26.404 23.07c.952 0 1.61-.602 1.61-3.591v-.189h1.14V23h1.359v-4.9h-3.766v.679c0 2.968-.364 3.164-.75 3.164-.062 0-.251-.014-.314-.028l-.091 1.043c.105.035.455.112.812.112Z",
    fill: "currentColor"
  })));
};

var _path$C;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M7.63.356 13.34 6l-5.708 5.644M0 6h9.554",
    stroke: "currentColor",
    strokeWidth: 1.568,
    strokeMiterlimit: 10
  })));
};

var _g$2, _defs$2;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var SvgGlobal = function SvgGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#global_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.966 4.65a.19.19 0 0 0-.002-.02c-.027-.04-.061-.074-.09-.112a11.297 11.297 0 0 0-1.586-1.742c-.048-.042-.092-.086-.14-.128-.64-.548-1.34-1.02-2.086-1.409l-.092-.044c-.333-.17-.674-.321-1.022-.455-.079-.029-.15-.055-.225-.079-.31-.112-.624-.21-.943-.293-.094-.025-.188-.051-.284-.073a10.99 10.99 0 0 0-.95-.175c-.098-.014-.194-.033-.292-.045-.828-.1-1.665-.1-2.493 0-.098.012-.194.031-.292.045-.321.046-.639.102-.95.175-.096.022-.19.048-.284.073-.322.084-.636.181-.944.293L7.067.74c-.348.134-.69.286-1.022.455l-.092.044c-.75.388-1.452.86-2.093 1.409-.048.042-.093.086-.14.128a10.223 10.223 0 0 0-.934.934c-.23.258-.448.527-.653.808-.028.038-.062.072-.09.111a.18.18 0 0 0-.009.021c-2.71 3.8-2.71 8.9 0 12.7a.165.165 0 0 0 .01.02c.027.04.061.074.09.112a11.002 11.002 0 0 0 1.585 1.742c.048.043.093.087.141.128.64.548 1.339 1.02 2.086 1.409l.092.044c.332.17.673.321 1.022.456.078.028.15.055.224.078.31.112.624.21.943.293.095.025.19.051.285.073.314.073.629.13.95.175.098.014.194.033.292.045.828.1 1.665.1 2.493 0 .098-.012.194-.031.291-.045.322-.046.64-.102.95-.175.097-.022.19-.048.285-.073.322-.084.636-.181.943-.293l.225-.078c.348-.135.69-.287 1.022-.456l.092-.044a11.02 11.02 0 0 0 2.086-1.409c.048-.041.092-.085.14-.128a10.015 10.015 0 0 0 .934-.934c.23-.258.448-.528.652-.808.029-.038.062-.072.09-.111a.176.176 0 0 0 .01-.021c2.71-3.8 2.71-8.9 0-12.7Zm-.896 1.487a9.353 9.353 0 0 1 1.325 4.077h-4.707a14.668 14.668 0 0 0-.44-2.773c1.33-.25 2.617-.688 3.822-1.303Zm-6.066-4.351c.044.01.086.024.13.034.281.066.56.142.833.236.042.014.083.03.124.046.27.094.537.199.797.314.046.021.09.045.136.066.25.119.495.248.733.386l.157.095c.226.138.446.286.66.444.055.04.11.079.164.123.21.157.41.325.603.505.05.046.102.09.151.138.201.19.393.393.579.602.023.027.048.052.072.078-1.064.507-2.192.87-3.352 1.077a19.987 19.987 0 0 0-2.116-4.198c.11.02.221.03.329.054Zm-5.115 8.428c.062-.85.207-1.693.432-2.515a22.576 22.576 0 0 0 5.369-.004c.225.824.369 1.667.43 2.52H7.889Zm6.23 1.572c-.061.85-.206 1.693-.431 2.515a22.509 22.509 0 0 0-2.684-.157 22.568 22.568 0 0 0-2.685.157 13.092 13.092 0 0 1-.43-2.515h6.23Zm-3.115-9.705a18.983 18.983 0 0 1 2.19 4.087 20.803 20.803 0 0 1-4.378 0 19.13 19.13 0 0 1 2.188-4.087ZM3.94 4.774c.184-.21.377-.411.578-.602.05-.047.102-.092.152-.138a9.74 9.74 0 0 1 .602-.505c.054-.042.11-.079.164-.123.214-.157.434-.305.66-.444l.157-.095c.239-.14.483-.268.733-.386.046-.021.09-.045.136-.066.26-.118.527-.222.798-.314.04-.015.078-.032.123-.046.273-.09.55-.166.833-.236.044-.01.087-.024.131-.033.108-.024.22-.035.329-.055a19.986 19.986 0 0 0-2.117 4.2 13.182 13.182 0 0 1-3.352-1.077c.024-.027.05-.053.073-.08Zm-1 1.364A14.121 14.121 0 0 0 6.76 7.44a14.666 14.666 0 0 0-.44 2.773H1.614A9.353 9.353 0 0 1 2.94 6.137Zm0 9.725a9.352 9.352 0 0 1-1.326-4.077h4.708c.058.937.205 1.865.44 2.774-1.33.249-2.617.688-3.822 1.303Zm6.066 4.351c-.044-.01-.087-.024-.13-.034a8.479 8.479 0 0 1-.834-.236c-.041-.014-.082-.03-.123-.046-.27-.094-.537-.198-.798-.314-.045-.021-.09-.045-.136-.066-.25-.119-.494-.248-.732-.386l-.158-.095a9.167 9.167 0 0 1-.66-.444c-.055-.04-.11-.079-.164-.123a7.165 7.165 0 0 1-.602-.505c-.05-.046-.102-.09-.152-.137a9.767 9.767 0 0 1-.578-.602l-.072-.08a13.185 13.185 0 0 1 3.352-1.076 19.983 19.983 0 0 0 2.115 4.199c-.109-.02-.22-.031-.328-.055Zm2-.295a18.977 18.977 0 0 1-2.191-4.087 20.47 20.47 0 0 1 4.38 0h-.002a19.13 19.13 0 0 1-2.188 4.087Zm7.065-2.693c-.185.21-.377.411-.579.602l-.151.138a9.339 9.339 0 0 1-1.427 1.072l-.157.095a9.61 9.61 0 0 1-.732.386c-.046.021-.09.045-.136.066-.261.118-.528.222-.798.314-.041.015-.079.032-.123.046-.273.091-.55.166-.834.236-.044.01-.086.024-.13.034-.108.023-.22.034-.33.054a19.978 19.978 0 0 0 2.116-4.199c1.16.208 2.288.57 3.352 1.077-.022.027-.047.052-.071.08Zm1-1.363a14.122 14.122 0 0 0-3.822-1.303c.235-.909.382-1.838.44-2.774h4.707a9.354 9.354 0 0 1-1.325 4.077Z",
    fill: "currentColor"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "global_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h22v22H0z"
  })))));
};

var _path$B;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.52 16H4.48A4.482 4.482 0 0 1 0 11.52V4.48A4.482 4.482 0 0 1 4.48 0h7.04A4.482 4.482 0 0 1 16 4.48v7.04A4.482 4.482 0 0 1 11.52 16Zm-.04-14H4.52A2.521 2.521 0 0 0 2 4.52v6.96A2.521 2.521 0 0 0 4.52 14h6.96A2.521 2.521 0 0 0 14 11.48V4.52A2.521 2.521 0 0 0 11.48 2Zm.52 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 4c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4Zm0 2a2 2 0 1 1-.001 4.001A2 2 0 0 1 8 6Z",
    fill: "currentColor"
  })));
};

var _path$A;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var SvgLecturer = function SvgLecturer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.5 9.245 1.138a.5.5 0 0 0-.49 0l-6.98 3.926a.5.5 0 0 0 0 .872l6.98 3.926a.5.5 0 0 0 .49 0L17 5.5Zm0 0v3.938M4 10v2.191a.5.5 0 0 0 .276.447l4.5 2.25a.5.5 0 0 0 .448 0l4.5-2.25a.5.5 0 0 0 .276-.447V10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    stroke: "currentColor"
  })));
};

var _path$z, _path2$a;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.175c0-1.4-1.094-2.144-2.625-2.144h-4.419c.306-1.181.482-2.319.482-3.281 0-3.806-1.05-4.594-1.97-4.594-.612 0-1.05.044-1.662.438-.175.087-.262.262-.306.437l-.656 3.544c-.7 1.881-2.494 3.5-3.938 4.594v9.362c.482 0 1.094.263 1.663.569.7.35 1.443.7 2.275.7H16.6c1.313 0 2.275-1.05 2.275-1.969 0-.175 0-.35-.044-.481.832-.306 1.357-1.006 1.357-1.794 0-.393-.088-.743-.22-1.006.482-.35 1.007-.919 1.007-1.619 0-.35-.175-.787-.438-1.093.57-.438.963-1.05.963-1.663Zm-1.356 0c0 .831-.875.919-1.006 1.313-.132.437.524.612.524 1.4 0 .83-1.006.83-1.137 1.225-.175.48.306.656.306 1.443v.132c-.131.656-1.137.7-1.312.962-.175.306.044.481.044 1.181 0 .394-.438.657-.963.657h-6.256c-.481 0-1.094-.263-1.663-.57-.525-.262-1.05-.524-1.618-.655v-6.957C8.68 9.081 10.78 7.2 11.613 4.925c0-.044 0-.087.043-.087l.613-3.282c.219-.087.393-.087.743-.087.132 0 .657.787.657 3.281 0 .963-.175 2.056-.525 3.281h-.175a.673.673 0 0 0-.656.656c0 .35.306.657.656.657h5.906c.656 0 1.269.306 1.269.831Z",
    fill: "currentColor"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 19.844H1.812A1.29 1.29 0 0 1 .5 18.53V9.344A1.29 1.29 0 0 1 1.813 8.03H5.75a1.29 1.29 0 0 1 1.313 1.313v9.187a1.29 1.29 0 0 1-1.313 1.313Zm-3.938-10.5v9.187H5.75V9.344H1.812Z",
    fill: "currentColor"
  })));
};

var _path$y;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H0v-1.998h10V14ZM16 10.003H0v-2.01h16v2.01ZM16 6.007H0v-2.01h16v2.01ZM16 2.01H0V0h16v2.01Z",
    fill: "currentColor"
  })));
};

var _path$x;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.251 6.461c-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615V6.461z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "0.6s",
    repeatCount: "indefinite"
  }))));
};

var _path$w, _path2$9;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M18.071 3.973A9.86 9.86 0 0 0 11 1a9.86 9.86 0 0 0-7.071 2.973A10.162 10.162 0 0 0 1 11.151c0 5.485 5.11 10.047 7.854 12.498.381.34.71.634.973.883a1.7 1.7 0 0 0 2.346 0c.262-.248.592-.543.973-.883C15.891 21.198 21 16.636 21 11.15c0-2.712-1.04-5.26-2.929-7.178Zm-5.84 18.62c-.39.348-.726.649-1.004.912a.33.33 0 0 1-.454 0 47.783 47.783 0 0 0-1.004-.912C7.189 20.29 2.385 16 2.385 11.151c0-4.822 3.865-8.745 8.615-8.745s8.615 3.923 8.615 8.745c0 4.849-4.803 9.138-7.384 11.442Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.001 6.294c-2.43 0-4.407 2.006-4.407 4.473s1.977 4.474 4.407 4.474c2.43 0 4.407-2.007 4.407-4.474s-1.977-4.473-4.407-4.473Zm0 7.54c-1.666 0-3.022-1.375-3.022-3.067 0-1.691 1.356-3.067 3.022-3.067 1.667 0 3.022 1.376 3.022 3.067 0 1.692-1.355 3.068-3.022 3.068Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.8
  })));
};

var _path$v, _path2$8;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var SvgLoupe = function SvgLoupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    d: "M10.277 5.514a4.764 4.764 0 1 1-9.527 0 4.764 4.764 0 0 1 9.527 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    d: "m9.19 9.189 3.06 3.062",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

var _path$u, _path2$7;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var SvgMarkAttention = function SvgMarkAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 23.833H3.792c-.65 0-1.192-.108-1.733-.541-.65-.325-1.192-1.084-1.409-1.95-.216-.867-.108-1.734.325-2.492l9.209-15.167c.325-.433.65-.758 1.083-1.083a3.31 3.31 0 0 1 4.442 1.083l9.208 15.275c.325.434.433 1.084.433 1.625 0 1.842-1.408 3.25-3.25 3.25ZM12.025 4.767l-9.1 15.275c-.216.325-.216.65-.108.758.108.217.217.542.433.65.217.217.325.217.542.217H22.1c.65 0 1.084-.434 1.084-1.084 0-.108-.109-.325-.109-.433L13.867 4.767c-.325-.434-.975-.65-1.517-.325 0 .108-.108.216-.325.325Z",
    fill: "currentColor"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.167c-.65 0-1.083-.434-1.083-1.084V9.75c0-.65.433-1.083 1.083-1.083.65 0 1.084.433 1.084 1.083v4.333c0 .65-.434 1.084-1.084 1.084Zm0 4.333c-.325 0-.541-.108-.758-.325-.217-.217-.325-.433-.325-.758 0-.109 0-.325.108-.434.109-.108.109-.216.217-.325a1.047 1.047 0 0 1 1.517 0c.108.109.216.217.216.325 0 .109.109.325.109.434 0 .108 0 .325-.109.433-.108.108-.108.217-.216.325-.217.217-.434.325-.759.325Z",
    fill: "currentColor"
  })));
};

var _path$t, _path2$6;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var SvgMarkInfo = function SvgMarkInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M14 .875C6.752.875.875 6.752.875 14S6.752 27.125 14 27.125 27.125 21.248 27.125 14 21.248.875 14 .875Zm0 24.023c-6.018 0-10.898-4.88-10.898-10.898S7.982 3.102 14 3.102 24.898 7.982 24.898 14 20.018 24.898 14 24.898Z",
    fill: "currentColor"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.594 8.844a1.406 1.406 0 1 0 2.812 0 1.406 1.406 0 0 0-2.812 0Zm2.11 3.281h-1.407a.235.235 0 0 0-.235.234v7.97c0 .128.106.233.235.233h1.406a.235.235 0 0 0 .235-.234V12.36a.235.235 0 0 0-.235-.234Z",
    fill: "currentColor"
  })));
};

var _path$s, _path2$5, _path3$1;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var SvgMarkQuestion = function SvgMarkQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.762a.977.977 0 1 0 0-1.953.977.977 0 0 0 0 1.953Z",
    fill: "currentColor"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.473 0 0 4.473 0 10s4.473 10 10 10 10-4.473 10-10S15.527 0 10 0Zm0 18.438A8.433 8.433 0 0 1 1.562 10 8.433 8.433 0 0 1 10 1.562 8.433 8.433 0 0 1 18.438 10 8.433 8.433 0 0 1 10 18.438Z",
    fill: "currentColor"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.02a3.129 3.129 0 0 0-3.125 3.125.781.781 0 1 0 1.563 0c0-.862.7-1.563 1.562-1.563.862 0 1.563.701 1.563 1.563 0 .861-.701 1.562-1.563 1.562a.781.781 0 0 0-.781.781v1.953a.781.781 0 1 0 1.562 0v-1.27a3.13 3.13 0 0 0 2.344-3.026A3.129 3.129 0 0 0 10 5.02Z",
    fill: "currentColor"
  })));
};

var _path$r;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    viewBox: "0 0 33 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.337 43.328H10.67a2.668 2.668 0 0 1 0-5.333h.005c.216 0 .4-.157.435-.37a.44.44 0 0 0-.293-.491l-.147-.051C4.46 34.886.003 28.955.003 21.995v-2.667a2.668 2.668 0 0 1 5.334 0v2.611c0 5.888 4.778 10.667 10.666 10.667 5.888 0 10.667-4.779 10.667-10.667v-2.61a2.668 2.668 0 0 1 5.333 0v2.666c0 6.96-4.456 12.89-10.666 15.088l-.147.05a.439.439 0 0 0-.293.491.44.44 0 0 0 .434.371h.006a2.668 2.668 0 0 1 0 5.333Zm2.667-34.667c0-4.416-3.584-8-8-8s-8 3.584-8 8v12.33c0 4.417 3.584 8 8 8s8-3.583 8-8V8.662Z",
    fill: "currentColor"
  })));
};

var _path$q, _path2$4;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.729 30 0 23.271 0 15S6.729 0 15 0s15 6.729 15 15-6.729 15-15 15Zm0-28.125C7.763 1.875 1.875 7.763 1.875 15c0 7.238 5.888 13.125 13.125 13.125 7.238 0 13.125-5.887 13.125-13.125 0-7.237-5.887-13.125-13.125-13.125Z",
    fill: "currentColor"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.563 15.938H8.438a.938.938 0 0 1 0-1.876h13.124a.938.938 0 0 1 0 1.876Z",
    fill: "currentColor"
  })));
};

var _path$p;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var SvgMoviePlay = function SvgMoviePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.785c0 .89-.721 1.611-1.61 1.611H1.61A1.61 1.61 0 0 1 0 17.786V2.214C0 1.325.721.604 1.61.604h16.78c.889 0 1.61.721 1.61 1.61v15.571Zm-13.893-.402h2.886V15.1H6.107v2.282ZM4.094 2.617h-2.08V4.9h2.08V2.617Zm0 12.484h-2.08v2.282h2.08V15.1Zm4.9-12.484H6.106V4.9h2.886V2.617ZM8.254 8.14v3.72c0 .553.394.758.857.455l2.7-1.763c.464-.304.468-.8.004-1.103L9.11 7.685c-.463-.303-.855-.098-.855.455Zm5.638-5.523h-2.886V4.9h2.886V2.617Zm0 12.484h-2.886v2.282h2.886V15.1Zm4.094-12.484h-2.081V4.9h2.08V2.617Zm0 12.484h-2.081v2.282h2.08V15.1Z",
    fill: "currentColor"
  })));
};

var _rect$6, _rect2$2;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect$6 || (_rect$6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    rx: 2,
    fill: "currentColor"
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 4,
    height: 14,
    rx: 2,
    fill: "currentColor"
  })));
};

var _path$o;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.992 4.893C2.399 4.57 2 3.968 2 3.28V1.868C2 .837 2.896 0 4 0s2 .837 2 1.868V3.28c0 .688-.399 1.29-.992 1.613v.496C6.66 5.393 8 6.647 8 8.191v.186C8 8.721 7.701 9 7.333 9H.667C.299 9 0 8.721 0 8.377v-.186c0-1.544 1.34-2.798 2.992-2.802v-.496Z",
    fill: "currentColor"
  })));
};

var _path$n;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M1.098 15.351a.7.7 0 0 0 .711-.018l11.216-7.01a.7.7 0 0 0 0-1.19L1.81.124A.701.701 0 0 0 .737.719v14.02c0 .255.138.49.36.613Z",
    fill: "currentColor"
  })));
};

var _path$m;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var SvgPlayBack = function SvgPlayBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M2.91 3.548A10.971 10.971 0 0 1 11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11a1 1 0 1 1 2 0 9 9 0 1 0 2.292-6h1.253a1 1 0 0 1 0 2H1.91a1 1 0 0 1-1-1V2.364a1 1 0 1 1 2 0v1.184Z",
    fill: "currentColor"
  })));
};

var _path$l;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var SvgPlayForward = function SvgPlayForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M19.09 3.548A10.972 10.972 0 0 0 11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11a1 1 0 1 0-2 0 9 9 0 1 1-2.291-6h-1.255a1 1 0 1 0 0 2h3.637a1 1 0 0 0 1-1V2.364a1 1 0 1 0-2 0v1.184Z",
    fill: "currentColor"
  })));
};

var _circle, _path$k;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var SvgPlayInCircle = function SvgPlayInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "currentColor"
  })), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 39.634a1 1 0 0 1 0 1.732l-11.25 6.495a1 1 0 0 1-1.5-.866v-12.99a1 1 0 0 1 1.5-.866l11.25 6.495Z",
    fill: "currentColor"
  })));
};

var _path$j, _path2$3, _path3;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.729 30 0 23.271 0 15S6.729 0 15 0s15 6.729 15 15-6.729 15-15 15Zm0-28.125C7.763 1.875 1.875 7.763 1.875 15c0 7.238 5.888 13.125 13.125 13.125 7.238 0 13.125-5.887 13.125-13.125 0-7.237-5.887-13.125-13.125-13.125Z",
    fill: "currentColor"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.563 15.938H8.438a.938.938 0 0 1 0-1.876h13.124a.938.938 0 0 1 0 1.876Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5a.938.938 0 0 1-.938-.938V8.438a.938.938 0 0 1 1.876 0v13.126c0 .517-.42.937-.938.937Z",
    fill: "currentColor"
  })));
};

var _rect$5, _rect2$1, _rect3$1, _rect4$1;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var SvgProductsGrid = function SvgProductsGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect$5 || (_rect$5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.451,
    y: 0.65,
    width: 5.9,
    height: 5.9,
    rx: 1.35,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 5.9,
    height: 5.9,
    rx: 1.35,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/React.createElement("rect", {
    x: 9.451,
    y: 9.45,
    width: 5.9,
    height: 5.9,
    rx: 1.35,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect4$1 || (_rect4$1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 9.45,
    width: 5.9,
    height: 5.9,
    rx: 1.35,
    stroke: "currentColor",
    strokeWidth: 1.3
  })));
};

var _rect$4, _g$1, _defs$1;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#AFC1D9"
  })), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#question_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.78 51.828c0-.568-.105-1.106-.314-1.614a3.848 3.848 0 0 0-.897-1.324 4.6 4.6 0 0 0-1.346-.897 3.953 3.953 0 0 0-1.615-.336c-.568 0-1.106.112-1.614.337-.509.224-.95.523-1.324.896a4.008 4.008 0 0 0-.874 1.324 4.199 4.199 0 0 0-.314 1.614c0 .569.104 1.107.314 1.615.209.509.5.95.874 1.324.374.373.815.672 1.324.897a3.953 3.953 0 0 0 1.614.336c.569 0 1.107-.112 1.615-.336a4.602 4.602 0 0 0 1.346-.898c.389-.373.688-.814.897-1.323.21-.508.314-1.046.314-1.615Zm-3.858-6.01h-.359a3.504 3.504 0 0 1-2.355-1.301 3.39 3.39 0 0 1-.784-2.557c.179-1.644.59-3.237 1.233-4.777a15.513 15.513 0 0 1 2.49-4.104c.328-.419.687-.8 1.076-1.144.389-.344.778-.68 1.166-1.01.987-.837 1.742-1.584 2.265-2.242.524-.658.785-1.465.785-2.422 0-.838-.172-1.526-.515-2.064a4.1 4.1 0 0 0-1.256-1.278 5.237 5.237 0 0 0-1.548-.673 5.998 5.998 0 0 0-1.435-.202h-.09c-.837 0-1.525.112-2.063.337a3.86 3.86 0 0 0-1.368.942c-.374.403-.688.89-.942 1.457a62.165 62.165 0 0 0-.785 1.84c-.36.926-.793 1.577-1.301 1.95-.508.374-1.017.591-1.525.651-.568.12-1.152.075-1.75-.134-.598-.24-1.076-.584-1.435-1.032-.329-.389-.583-.89-.763-1.503-.179-.613-.12-1.368.18-2.265.18-.568.493-1.383.942-2.445.448-1.061 1.129-2.1 2.04-3.117.913-1.017 2.087-1.9 3.522-2.647 1.435-.747 3.23-1.106 5.383-1.076a13.44 13.44 0 0 1 4.238.785 11.61 11.61 0 0 1 3.746 2.175c1.107.957 2.003 2.13 2.691 3.521.688 1.39 1.032 2.983 1.032 4.778 0 1.315-.18 2.482-.538 3.498a11.702 11.702 0 0 1-1.368 2.736 12.558 12.558 0 0 1-1.795 2.109c-.643.598-1.233 1.136-1.771 1.615-.3.269-.584.515-.853.74a3.61 3.61 0 0 0-.628.65 9.436 9.436 0 0 0-1.368 2.31 9.233 9.233 0 0 0-.695 2.76c-.09.926-.471 1.681-1.144 2.264a3.486 3.486 0 0 1-2.355.875Z",
    fill: "#fff"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "question_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 15)",
    d: "M0 0h41v41H0z"
  })))));
};

var _path$i;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgRozLogo = function SvgRozLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.585v-9.17A6.423 6.423 0 0 0 15.585 0h-9.17A6.423 6.423 0 0 0 0 6.415v9.17a6.389 6.389 0 0 0 5.757 6.374l6.744-5.47H5.222v-2.631l7.197-5.88H5.51V5.469h11.226v2.632L9.54 13.98h7.196v2.632L10.116 22h5.469A6.423 6.423 0 0 0 22 15.585Z",
    fill: "currentColor"
  })));
};

var _path$h, _path2$2;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M13.152 8.389a4.764 4.764 0 1 1-9.527 0 4.764 4.764 0 0 1 9.527 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.064 12.064 3.06 3.062",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

var _path$g;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M10.526 5c-5.529 0-8.6 3.593-9.911 6.355-.216.455.328.812.733.513C5.147 9.074 8.958 9.404 10.526 10v4.923a.5.5 0 0 0 .823.382l8.199-6.923a.5.5 0 0 0 0-.764l-8.2-6.923a.5.5 0 0 0-.822.382V5Z",
    stroke: "currentColor"
  })));
};

var _path$f, _path2$1;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgSheet = function SvgSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M13.644 3.64 10.443.365V3.64h3.2Z",
    fill: "currentColor"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.226 4.262V0H.608A.615.615 0 0 0 0 .622v16.756c0 .343.272.622.608.622h12.784a.615.615 0 0 0 .608-.622V4.884H9.834a.615.615 0 0 1-.608-.622Z",
    fill: "currentColor"
  })));
};

var _path$e;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.227 16.76c-1.202.808-3.235 2.143-5.274 3.481-.318.272-.761.338-1.205.159-.646-.263-.775-.918-.517-1.574l1.68-6.425L.416 8.223C.17 8.021 0 7.72 0 7.418c0-.656.517-1.049 1.034-1.049h5.857L9.254.775C9.47.276 9.86 0 10.34 0h.012c.474.007.861.28 1.075.775l2.363 5.594h5.857c.517 0 1.034.393 1.034 1.049 0 .302-.171.603-.415.805l-4.497 4.178 1.68 6.425c.259.656.13 1.311-.517 1.573-.443.18-.886.114-1.204-.158a681.89 681.89 0 0 1-5.388-3.557l-.113.077Z",
    fill: "currentColor"
  })));
};

var _g, _defs;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgStarGradient = function SvgStarGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#star-gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.394 6.395 2.615-.534a3.15 3.15 0 0 0 2.08-1.502L8.154.844a1.55 1.55 0 0 1 2.692 0L12.91 4.36a3.15 3.15 0 0 0 2.08 1.502l2.615.534c1.237.252 1.698 1.828.801 2.743l-2.195 2.242a3.31 3.31 0 0 0-.87 2.946l.406 2.071c.259 1.322-1.068 2.373-2.24 1.775l-2.612-1.334a3.062 3.062 0 0 0-2.792 0l-2.612 1.334c-1.171.598-2.499-.453-2.24-1.775l.406-2.07a3.31 3.31 0 0 0-.87-2.947L.592 9.138c-.896-.915-.435-2.49.802-2.743Z",
    fill: "url(#star-gradient_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-gradient_svg__b",
    x1: 9.5,
    y1: 0.063,
    x2: 9.5,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#F5D665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8D25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "star-gradient_svg__a",
    x: -3.875,
    y: -3.938,
    width: 24.75,
    height: 24.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.97625 0 0 0 0 0.7625 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5797:76"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.704167 0 0 0 0 0.4225 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_5797:76",
    result: "effect2_innerShadow_5797:76"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.995917 0 0 0 0 1 0 0 0 0 0.795833 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_innerShadow_5797:76",
    result: "effect3_innerShadow_5797:76"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.64025 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_innerShadow_5797:76",
    result: "effect4_innerShadow_5797:76"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.8375 0 0 0 0 0.544182 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_innerShadow_5797:76",
    result: "effect5_innerShadow_5797:76"
  })))));
};

var _rect$3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.283,
    width: 11.429,
    height: 22.857,
    rx: 5.714,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.857,
    y: 34.287,
    width: 11.429,
    height: 22.857,
    rx: 5.714,
    transform: "rotate(90 22.857 34.287)",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 34.287,
    width: 11.429,
    height: 22.857,
    rx: 5.714,
    transform: "rotate(90 80 34.287)",
    fill: "currentColor",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.283,
    y: 57.143,
    width: 11.429,
    height: 22.857,
    rx: 5.714,
    fill: "currentColor",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.408,
    y: 15.871,
    width: 11.852,
    height: 22.222,
    rx: 5.926,
    transform: "rotate(-45.57 7.408 15.871)",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11.852,
    height: 22.222,
    rx: 5.926,
    transform: "scale(1 -1) rotate(-45.57 -73.007 -41.04)",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.852,
    height: 22.222,
    rx: 5.926,
    transform: "scale(-1 1) rotate(-45.57 -17.265 94.014)",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.314,
    y: 64.445,
    width: 11.852,
    height: 22.222,
    rx: 5.926,
    transform: "rotate(134.43 72.314 64.445)",
    fill: "currentColor",
    fillOpacity: 0.5
  })));
};

var _rect$2, _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#426FFF"
  })), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "m17 33 12.824 15.077a1 1 0 0 0 1.543-.024L53 21",
    stroke: "#fff",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
};

var _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M14.701.42.526 5.913c-.57.256-.764.768-.138 1.046l3.637 1.162 8.792-5.462c.48-.343.972-.252.549.126L5.814 9.659l-.237 2.908c.22.45.622.451.879.228l2.089-1.987 3.578 2.693c.831.495 1.284.176 1.462-.73l2.347-11.172c.244-1.115-.171-1.607-1.23-1.18Z",
    fill: "currentColor"
  })));
};

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.704 13.452c6.247 0 9.664-5.176 9.664-9.664 0-.147 0-.294-.01-.439a6.927 6.927 0 0 0 1.437-1.398.128.128 0 0 0-.003-.153.126.126 0 0 0-.146-.042 6.815 6.815 0 0 1-1.544.369 3.407 3.407 0 0 0 1.4-1.622.1.1 0 0 0-.142-.122 6.877 6.877 0 0 1-1.92.69A3.404 3.404 0 0 0 10.961 0a3.416 3.416 0 0 0-3.4 3.4c0 .259.03.517.088.769A9.648 9.648 0 0 1 .786.783.146.146 0 0 0 .66.732a.144.144 0 0 0-.113.077 3.418 3.418 0 0 0 1.155 4.345c-.387-.012-1.01-.203-1.333-.31a.147.147 0 0 0-.137.023.147.147 0 0 0-.058.127c.08.679.492 2.704 2.712 3.107-.435.119-.888.15-1.333.091a.124.124 0 0 0-.113.044.122.122 0 0 0-.019.119 3.41 3.41 0 0 0 3.104 2.164 6.823 6.823 0 0 1-2.687 1.284c-.318.073-1.073.116-1.647.13a.186.186 0 0 0-.095.348 9.625 9.625 0 0 0 4.61 1.169",
    fill: "currentColor"
  })));
};

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.556 6.667a4.444 4.444 0 1 1 8.888 0 4.444 4.444 0 0 1-8.888 0Zm8.693 5.136a6.667 6.667 0 1 0-8.499 0C2.207 13.051 0 15.83 0 18.89a1.111 1.111 0 0 0 2.222 0c0-2.522 2.617-5.556 7.778-5.556s7.778 3.034 7.778 5.556a1.111 1.111 0 1 0 2.222 0c0-3.059-2.205-5.838-5.751-7.086Z",
    fill: "currentColor"
  })));
};

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.952 5.167S17.325 1.821 17.56.722C17.64.33 17.466.11 17.057.11H15c-.472 0-.644.204-.786.502 0 0-1.112 2.37-2.466 3.864-.434.483-.654.628-.895.628-.194 0-.283-.16-.283-.596V.69c0-.533-.063-.691-.502-.691H6.77c-.252 0-.41.146-.41.345 0 .503.771.617.771 1.98v2.81c0 .567-.031.786-.299.786-.706 0-2.387-2.435-3.33-5.199C3.314.157 3.11 0 2.576 0H.52C.219 0 0 .204 0 .503c0 .549.644 3.094 3.173 6.502C4.869 9.298 7.1 10.54 9.11 10.54c1.225 0 1.524-.204 1.524-.722v-1.76c0-.44.173-.628.424-.628.282 0 .781.09 1.947 1.241 1.383 1.319 1.477 1.869 2.23 1.869h2.31c.236 0 .455-.11.455-.503 0-.517-.675-1.444-1.712-2.543-.424-.566-1.115-1.18-1.336-1.462-.313-.33-.219-.518 0-.864Z",
    fill: "currentColor"
  })));
};

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgVolumeDown = function SvgVolumeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.652 4.348a3.752 3.752 0 0 1 0 5.304M3.19 9.25H2a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 2 4.75h1.19l3.53-3.53A.75.75 0 0 1 8 1.75v10.5a.75.75 0 0 1-1.28.53L3.19 9.25Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$7, _rect$1;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.536 8.464a5.001 5.001 0 0 1 0 7.072m2.828-9.9a9 9 0 0 1 0 12.728M5.586 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.833,
    width: 3,
    height: 24,
    rx: 1.5,
    transform: "rotate(-37.673 4 3.833)",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgVolumeUp = function SvgVolumeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.652 4.348a3.752 3.752 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546M3.189 9.25H2a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 2 4.75h1.19l3.53-3.53A.75.75 0 0 1 8 1.75v10.5a.75.75 0 0 1-1.28.53L3.19 9.25Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _rect, _path$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F0304E"
  })), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 48.75A6.257 6.257 0 0 1 34.5 55a6.257 6.257 0 0 1-6.25-6.25 6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25ZM28.973 16.969l1.063 21.25c.05.998.873 1.781 1.873 1.781h5.182c1 0 1.823-.783 1.873-1.781l1.063-21.25A1.875 1.875 0 0 0 38.154 15h-7.308a1.875 1.875 0 0 0-1.873 1.969Z",
    fill: "#fff"
  })));
};

var _path$4, _path2;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgWork = function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.706 3.774A3.306 3.306 0 0 1 21.01 7.09v3.727c-2.665 1.56-6.186 2.502-10.02 2.502-3.836 0-7.346-.942-10.01-2.502V7.079a3.306 3.306 0 0 1 3.314-3.305h13.412Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.787 3.77v-.397A2.395 2.395 0 0 0 12.392.98H9.597a2.395 2.395 0 0 0-2.394 2.394v.397M1.006 14.773l.204 2.718a3.512 3.512 0 0 0 3.502 3.248h12.565a3.512 3.512 0 0 0 3.502-3.248l.204-2.718",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.182.912A3.662 3.662 0 0 0 .917 4.32a42.138 42.138 0 0 0 0 5.362 3.66 3.66 0 0 0 3.265 3.406c1.838.186 3.792.286 5.817.286 2.025 0 3.978-.1 5.816-.285A3.662 3.662 0 0 0 19.08 9.68a42.15 42.15 0 0 0 0-5.362A3.66 3.66 0 0 0 15.815.913 57.96 57.96 0 0 0 9.999.627c-2.025 0-3.979.1-5.817.285ZM8.3 9.745 12.8 7 8.3 4.255v5.49Z",
    fill: "currentColor"
  })));
};

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.528 1.572A4.93 4.93 0 0 0 12.926 0a4.937 4.937 0 0 0-3.607 1.572l-.318.336-.317-.336a4.922 4.922 0 0 0-7.212 0 5.52 5.52 0 0 0 0 7.506l7.062 7.447a.643.643 0 0 0 .934 0l7.06-7.447a5.52 5.52 0 0 0 0-7.506Zm-.93 6.62h-.002l-6.595 6.956-6.595-6.956a4.218 4.218 0 0 1 0-5.735 3.636 3.636 0 0 1 5.344 0l.784.827a.663.663 0 0 0 .934 0l.785-.826a3.636 3.636 0 0 1 5.344 0c1.513 1.62 1.524 4.124 0 5.734Z",
    fill: "currentColor"
  })));
};

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgHeartFull = function SvgHeartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.528 2.21A4.93 4.93 0 0 0 12.926.636a4.937 4.937 0 0 0-3.607 1.572l-.318.335-.317-.335a4.922 4.922 0 0 0-7.212 0 5.52 5.52 0 0 0 0 7.506l7.062 7.447a.643.643 0 0 0 .934 0l7.06-7.447a5.52 5.52 0 0 0 0-7.506Z",
    fill: "currentColor"
  })));
};

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBookmarkFull = function SvgBookmarkFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.143 1H2.857C1.836 1 1 1.8 1 2.778v12.73a1 1 0 0 0 1.38.926l5.12-2.1 5.12 2.1a1 1 0 0 0 1.38-.925V2.778C14 1.8 13.164 1 12.143 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
};

var iconsMap = {
    'animated-spinner': SvgAnimatedSpinner,
    arrow: SvgArrow,
    'arrow-accordion': SvgArrowAccordion,
    'arrow-accordion-up': SvgArrowAccordionUp,
    'arrow-button': SvgArrowButton,
    'arrow-forward-ios': SvgArrowForwardIos,
    'arrow-in-circle': SvgArrowInCircle,
    'arrow-long': SvgArrowLong,
    'arrow-profile': SvgArrowProfile,
    'arrow-quiz-slider': SvgArrowQuizSlider,
    'arrow-right': SvgArrowRight,
    'arrow-scroll-up': SvgArrowScrollUp,
    'arrow-top-right': SvgArrowTopRight,
    'arrow-bottom-right': SvgArrowBottomRight,
    back: SvgBack,
    bookmark: SvgBookmark,
    burger: SvgBurger,
    'burger-lower': SvgBurgerLower,
    calendar: SvgCalendar,
    calendar2: SvgCalendar2,
    clip: SvgClip,
    'check-mark': SvgCheckMark,
    'check-mark-circle': SvgCheckMarkCircle,
    clock: SvgClock,
    close: SvgClose,
    'close-circle': SvgCloseCircle,
    'close-circle-bg': SvgCloseCircleBg,
    copy: SvgCopy,
    desk: SvgDesk,
    'doc-file': SvgDocFile,
    'doc-with-cross': SvgDocWithCross,
    download: SvgDownload,
    edit: SvgEdit,
    email: SvgEmail,
    eye: SvgEye,
    'eye-close': SvgEyeClose,
    facebook: SvgFacebook,
    file: SvgFile,
    forward: SvgForward,
    global: SvgGlobal,
    instagram: SvgInstagram,
    lecturer: SvgLecturer,
    like: SvgLike,
    list: SvgList,
    loader: SvgLoader,
    location: SvgLocation,
    loupe: SvgLoupe,
    'mark-attention': SvgMarkAttention,
    'mark-info': SvgMarkInfo,
    'mark-question': SvgMarkQuestion,
    mic: SvgMic,
    minus: SvgMinus,
    'movie-play': SvgMoviePlay,
    pause: SvgPause,
    person: SvgPerson,
    play: SvgPlay,
    'play-back': SvgPlayBack,
    'play-forward': SvgPlayForward,
    'play-in-circle': SvgPlayInCircle,
    plus: SvgPlus,
    'products-grid': SvgProductsGrid,
    question: SvgQuestion,
    'roz-logo': SvgRozLogo,
    search: SvgSearch,
    share: SvgShare,
    sheet: SvgSheet,
    spinner: SvgSpinner,
    star: SvgStar,
    'star-gradient': SvgStarGradient,
    success: SvgSuccess,
    telegram: SvgTelegram,
    twitter: SvgTwitter,
    user: SvgUser,
    vk: SvgVk,
    'volume-down': SvgVolumeDown,
    'volume-off': SvgVolumeOff,
    'volume-up': SvgVolumeUp,
    warning: SvgWarning,
    work: SvgWork,
    youtube: SvgYoutube,
    heart: SvgHeart,
    'heart-full': SvgHeartFull,
    'bookmark-full': SvgBookmarkFull,
};

var UiIcon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 24 : _b, width = _a.width, height = _a.height, props = __rest(_a, ["name", "size", "width", "height"]);
    try {
        var Icon = iconsMap[name];
        var w = width || size;
        var h = height || size;
        if (!Icon) {
            return null;
        }
        return React__default.createElement(Icon, __assign({ "data-testid": name, width: w, height: h }, props));
    }
    catch (err) {
        return null;
    }
};

var css$p = {"accordion":"Accordion_accordion__wD27Q","active":"Accordion_active__fteLj","title":"Accordion_title__-9-np","icon":"Accordion_icon__TdeJS","header":"Accordion_header__AYOT5"};

var UiAccordion = function (props) {
    var _a;
    var children = props.children, title = props.title, _b = props.isShow, isShow = _b === void 0 ? false : _b;
    var _c = useState(false), active = _c[0], setActive = _c[1];
    useEffect(function () {
        setActive(isShow);
    }, [isShow]);
    var toggle = function () { return setActive(function (active) { return !active; }); };
    return (React__default.createElement("div", { id: title, className: cn(css$p.accordion, (_a = {}, _a[css$p.active] = active, _a)) },
        React__default.createElement("div", { onClick: toggle, className: css$p.header },
            React__default.createElement("div", { className: css$p.title }, title),
            React__default.createElement(UiIcon, { width: "16px", className: css$p.icon, color: "#666C77", name: "arrow-accordion" })),
        active && React__default.createElement("div", null, children)));
};

var getElementType = function (Component, props) {
    var _a = Component.defaultProps, defaultProps = _a === void 0 ? {} : _a;
    if (props.as && props.as !== defaultProps.as) {
        return props.as;
    }
    if (props.href) {
        return 'a';
    }
    return defaultProps.as || 'div';
};

var css$o = {"block":"Button_block__3jdVm","small":"Button_small__zfmcP","medium":"Button_medium__HYxwi","large":"Button_large__iWceB","minWidth":"Button_minWidth__QaHXc","fluid":"Button_fluid__DBnBX","weightNormal":"Button_weightNormal__TcRu9","weightMedium":"Button_weightMedium__6B68y","weightBold":"Button_weightBold__MGkmZ","standard":"Button_standard__Sn26m","secondary":"Button_secondary__j-3rj","primary":"Button_primary__st6yY","inverted":"Button_inverted__bGHmY","dark":"Button_dark__T7dl8","outline":"Button_outline__TFr94","text":"Button_text__dcWb-","icon":"Button_icon__xIuVv","labeled":"Button_labeled__qxm-b","startIcon":"Button_startIcon__pTA6B","endIcon":"Button_endIcon__SYmHq","buttonText":"Button_buttonText__reUdv","loadingIcon":"Button_loadingIcon__7qBai"};

var UiButton = function (props) {
    var children = props.children, size = props.size, weight = props.weight, variant = props.variant, fluid = props.fluid, inverted = props.inverted, loading = props.loading, className = props.className, minWidth = props.minWidth, startIcon = props.startIcon, endIcon = props.endIcon, rest = __rest(props, ["children", "size", "weight", "variant", "fluid", "inverted", "loading", "className", "minWidth", "startIcon", "endIcon"]);
    var ElementType = getElementType(UiButton, props);
    var classes = cn(css$o.block, variant && css$o[variant], size && css$o[size], weight &&
        css$o["weight".concat(weight[0].toUpperCase() + weight.slice(1))], fluid && css$o.fluid, inverted && css$o.inverted, (startIcon || endIcon) && css$o.icon, (startIcon || endIcon) && children && css$o.labeled, startIcon && children && css$o.startIcon, endIcon && children && css$o.endIcon, minWidth && css$o.minWidth, className);
    return (React__default.createElement(ElementType, __assign({ className: classes }, rest),
        startIcon,
        React__default.createElement("span", { className: css$o.buttonText },
            loading && (React__default.createElement(UiIcon, { className: css$o.loadingIcon, name: "animated-spinner", width: 30, height: 30 })),
            children),
        endIcon));
};
UiButton.defaultProps = {
    as: 'button',
    size: 'medium',
    variant: 'standard',
    weight: 'normal',
    fluid: false,
    inverted: false,
    loading: false,
};

var getFormattedText = function (str, char) {
    return str.replace(/(?:\r\n|\r|\n)/g, char);
};

var css$n = {"blur":"Text_blur__A2YBy","btn":"Text_btn__K5fsq","hiddenContent":"Text_hiddenContent__B5kQh","visibleContent":"Text_visibleContent__em6Xp"};

var TextWrapper = function (_a) {
    var size = _a.size, withFormat = _a.withFormat, disableMore = _a.disableMore, children = _a.children, _b = _a.isBlur, isBlur = _b === void 0 ? false : _b, char = _a.char, onClickMore = _a.onClickMore;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var handleMore = function () {
        var isOpen = !open;
        setOpen(isOpen);
        if (onClickMore) {
            onClickMore(isOpen);
        }
    };
    var getChildren = function (isCroped) {
        /* фикс логики по корретному отображению скрытого текстового содержимого для SEO
        /* https://znanierussia.atlassian.net/browse/RU-428
         */
        var visibleContent = children;
        var hiddenContent = children;
        if (isCroped) {
            visibleContent =
                visibleContent.slice(0, size) + "<span id='dots'></span>";
            hiddenContent = hiddenContent.slice(size);
        }
        if (withFormat) {
            if (char) {
                visibleContent = getFormattedText(visibleContent, char);
            }
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: css$n.visibleContent, dangerouslySetInnerHTML: { __html: visibleContent } }),
                isCroped ? (React__default.createElement("div", { className: !open ? css$n.hiddenContent : '', dangerouslySetInnerHTML: { __html: hiddenContent } })) : null));
        }
        return (React__default.createElement(React__default.Fragment, null,
            visibleContent,
            isCroped ? (React__default.createElement("div", { className: !open ? css$n.hiddenContent : '' }, hiddenContent)) : null));
    };
    if (disableMore) {
        return React__default.createElement("div", null, getChildren(!(!size || children.length <= size)));
    }
    if (!size || children.length <= size) {
        return React__default.createElement("div", null, getChildren());
    }
    return (React__default.createElement(React__default.Fragment, null, open ? (React__default.createElement(React__default.Fragment, null,
        getChildren(),
        isBlur ? (React__default.createElement(UiButton, { variant: "outline", size: "small", onClick: handleMore, className: css$n.btn }, "\u0421\u043A\u0440\u044B\u0442\u044C")) : (React__default.createElement(UiText, { as: "a", onClick: handleMore }, "\u0441\u043A\u0440\u044B\u0442\u044C")))) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: isBlur ? css$n.blur : '' }, getChildren(true)),
        isBlur ? (React__default.createElement(UiButton, { variant: "outline", size: "small", onClick: handleMore, className: css$n.btn }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")) : (React__default.createElement(UiText, { as: "a", onClick: handleMore }, "\u0435\u0449\u0435"))))));
};

var css$m = {"block":"Text_block__4l8qH","large":"Text_large__aV0EW","normal":"Text_normal__8e8-I","small_plus":"Text_small_plus__MgvdR","small":"Text_small__-48A8","small_x":"Text_small_x__rH5y9","a":"Text_a__eFVEG","blue":"Text_blue__DUw3c","danger":"Text_danger__Bo30a","white":"Text_white__CcYJW","grey":"Text_grey__Zy8MO","medium":"Text_medium__FoS2D","bold":"Text_bold__ZRBJh","left":"Text_left__mLCig","center":"Text_center__tNTJk","right":"Text_right__WlaBU","uppercase":"Text_uppercase__Jaf2b","clickable":"Text_clickable__hORA4"};

var UiText = function (props) {
    var children = props.children;
    var as = props.as, align = props.align, size = props.size, weight = props.weight, className = props.className, color = props.color, uppercase = props.uppercase, truncateProps = props.truncateProps, rest = __rest(props, ["as", "align", "size", "weight", "className", "color", "uppercase", "truncateProps"]);
    var ElementType = getElementType(UiText, props);
    var classes = cn(css$m.block, align && css$m[align], size && css$m[size], weight && css$m[weight], as && css$m[as], color && css$m[color], uppercase && css$m.uppercase, rest.onClick && css$m.clickable, className);
    return (React__default.createElement(ElementType, __assign({ className: classes }, rest), truncateProps ? (React__default.createElement(Truncate, __assign({}, truncateProps), children)) : (children)));
};
UiText.defaultProps = {
    as: 'div',
    align: 'left',
    size: 'normal',
};
UiText.Wrapper = TextWrapper;

var css$l = {"breadcrumbs":"Breadcrumbs_breadcrumbs__R-ku-","segment":"Breadcrumbs_segment__rmGyi","text":"Breadcrumbs_text__ttfxp","delimiter":"Breadcrumbs_delimiter__BSdj7"};

var UiBreadcrumbs = function (_a) {
    var paths = _a.paths;
    return (React__default.createElement("div", { className: css$l.breadcrumbs }, paths.map(function (item, index) { return (React__default.createElement("li", { className: css$l.segment, key: "breadcrumb_segment_".concat(index) },
        index !== 0 && React__default.createElement("span", { className: css$l.delimiter }, "/"),
        index === paths.length - 1 ? (React__default.createElement(UiText, { className: css$l.text, size: "small_plus" }, item.label)) : (React__default.createElement("a", { href: item.url },
            React__default.createElement(UiText, { className: css$l.text, size: "small_plus" }, item.label))))); })));
};

var css$k = {"block":"Checkbox_block__7O0ta","input":"Checkbox_input__-039s","label":"Checkbox_label__JBaRm","checkbox":"Checkbox_checkbox__D0D4S","radio":"Checkbox_radio__185O0","top":"Checkbox_top__kIBF3","center":"Checkbox_center__KAeXv","disabled":"Checkbox_disabled__WagIC","checked":"Checkbox_checked__XfvkJ"};

var UiCheckbox = function (props) {
    var label = props.label, checked = props.checked, disabled = props.disabled, _a = props.type, type = _a === void 0 ? 'checkbox' : _a, _b = props.align, align = _b === void 0 ? 'center' : _b, onChange = props.onChange, rest = __rest(props, ["label", "checked", "disabled", "type", "align", "onChange"]);
    return (React__default.createElement("div", { className: css$k.block },
        React__default.createElement("label", { className: cn(css$k[type], css$k[align], checked && css$k.checked, disabled && css$k.disabled) },
            React__default.createElement("input", __assign({ className: cn(css$k.input), type: type, checked: checked, disabled: disabled, onChange: onChange }, rest)),
            typeof label === 'string' ? (React__default.createElement(UiText, { size: "small", as: "span", color: "grey", className: css$k.label }, label)) : (React__default.createElement("div", { className: css$k.label }, label)))));
};

function declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', count);
  }
}

function buildLocalizeTokenFn(scheme) {
  return function (count, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return 'через ' + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + ' назад';
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}

var formatDistanceLocale = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: 'меньше секунды',
      singularNominative: 'меньше {{count}} секунды',
      singularGenitive: 'меньше {{count}} секунд',
      pluralGenitive: 'меньше {{count}} секунд'
    },
    future: {
      one: 'меньше, чем через секунду',
      singularNominative: 'меньше, чем через {{count}} секунду',
      singularGenitive: 'меньше, чем через {{count}} секунды',
      pluralGenitive: 'меньше, чем через {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду назад',
      singularGenitive: '{{count}} секунды назад',
      pluralGenitive: '{{count}} секунд назад'
    },
    future: {
      singularNominative: 'через {{count}} секунду',
      singularGenitive: 'через {{count}} секунды',
      pluralGenitive: 'через {{count}} секунд'
    }
  }),
  halfAMinute: function (_, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'через полминуты';
      } else {
        return 'полминуты назад';
      }
    }

    return 'полминуты';
  },
  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: 'меньше минуты',
      singularNominative: 'меньше {{count}} минуты',
      singularGenitive: 'меньше {{count}} минут',
      pluralGenitive: 'меньше {{count}} минут'
    },
    future: {
      one: 'меньше, чем через минуту',
      singularNominative: 'меньше, чем через {{count}} минуту',
      singularGenitive: 'меньше, чем через {{count}} минуты',
      pluralGenitive: 'меньше, чем через {{count}} минут'
    }
  }),
  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} минута',
      singularGenitive: '{{count}} минуты',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минуту назад',
      singularGenitive: '{{count}} минуты назад',
      pluralGenitive: '{{count}} минут назад'
    },
    future: {
      singularNominative: 'через {{count}} минуту',
      singularGenitive: 'через {{count}} минуты',
      pluralGenitive: 'через {{count}} минут'
    }
  }),
  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} часа',
      singularGenitive: 'около {{count}} часов',
      pluralGenitive: 'около {{count}} часов'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} час',
      singularGenitive: 'приблизительно через {{count}} часа',
      pluralGenitive: 'приблизительно через {{count}} часов'
    }
  }),
  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} час',
      singularGenitive: '{{count}} часа',
      pluralGenitive: '{{count}} часов'
    }
  }),
  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} дней'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} недели',
      singularGenitive: 'около {{count}} недель',
      pluralGenitive: 'около {{count}} недель'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} неделю',
      singularGenitive: 'приблизительно через {{count}} недели',
      pluralGenitive: 'приблизительно через {{count}} недель'
    }
  }),
  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} неделя',
      singularGenitive: '{{count}} недели',
      pluralGenitive: '{{count}} недель'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} месяца',
      singularGenitive: 'около {{count}} месяцев',
      pluralGenitive: 'около {{count}} месяцев'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} месяц',
      singularGenitive: 'приблизительно через {{count}} месяца',
      pluralGenitive: 'приблизительно через {{count}} месяцев'
    }
  }),
  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяца',
      pluralGenitive: '{{count}} месяцев'
    }
  }),
  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} года',
      singularGenitive: 'около {{count}} лет',
      pluralGenitive: 'около {{count}} лет'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} год',
      singularGenitive: 'приблизительно через {{count}} года',
      pluralGenitive: 'приблизительно через {{count}} лет'
    }
  }),
  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} года',
      pluralGenitive: '{{count}} лет'
    }
  }),
  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'больше {{count}} года',
      singularGenitive: 'больше {{count}} лет',
      pluralGenitive: 'больше {{count}} лет'
    },
    future: {
      singularNominative: 'больше, чем через {{count}} год',
      singularGenitive: 'больше, чем через {{count}} года',
      pluralGenitive: 'больше, чем через {{count}} лет'
    }
  }),
  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'почти {{count}} год',
      singularGenitive: 'почти {{count}} года',
      pluralGenitive: 'почти {{count}} лет'
    },
    future: {
      singularNominative: 'почти через {{count}} год',
      singularGenitive: 'почти через {{count}} года',
      pluralGenitive: 'почти через {{count}} лет'
    }
  })
};
function formatDistance(token, count, options) {
  options = options || {};
  return formatDistanceLocale[token](count, options);
}

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
var timeFormats = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats = {
  any: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'any'
  })
};
var formatLong$1 = formatLong;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];

function lastWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}

function thisWeek(day) {
  var weekday = accusativeWeekdays[day];

  if (day === 2
  /* Tue */
  ) {
      return "'во " + weekday + " в' p";
    } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}

var formatRelativeLocale = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: 'P'
};
function formatRelative(token, date, baseDate, options) {
  var format = formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['до н.э.', 'н.э.'],
  abbreviated: ['до н. э.', 'н. э.'],
  wide: ['до нашей эры', 'нашей эры']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
var monthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
};
var formattingMonthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
var dayValues = {
  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
};
var dayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утро',
    afternoon: 'день',
    evening: 'вечер',
    night: 'ночь'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'вечера',
    night: 'ночи'
  }
};

function ordinalNumber(dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (unit === 'date') {
    suffix = '-е';
  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
    suffix = '-я';
  } else {
    suffix = '-й';
  }

  return dirtyNumber + suffix;
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
  any: [/^д/i, /^н/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var matchDayPatterns = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
var matchDayPeriodPatterns = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'ru',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var ru = locale;

var css$j = {"block":"Input_block__OoRy5","code":"Input_code__CVT0F","input":"Input_input__505b7","label":"Input_label__gmqts","field":"Input_field__ltN7X","icon":"Input_icon__qkecR","searchIcon":"Input_searchIcon__WnO0j","input_small":"Input_input_small__RlZ6g","input_normal":"Input_input_normal__3w5Zh","active":"Input_active__f4pI3","error":"Input_error__38tit","inputClear":"Input_inputClear__rcUaj","inputCopy":"Input_inputCopy__swjE5","inputSearch":"Input_inputSearch__M2r4G","fluid":"Input_fluid__-dfow","eye":"Input_eye__PqvZM","clear":"Input_clear__qoe5x","copy":"Input_copy__8eVrd","eyeClosed":"Input_eyeClosed__oTkhe","search":"Input_search__ixH73","counter":"Input_counter__OD8Aj","bottom":"Input_bottom__sSwwC"};

var ENTER_BTN_CODE = 'Enter';
var DELETE_BTN_CODE = 'Backspace';
var InputComponent = function (_a, ref) {
    var label = _a.label, errorLabel = _a.errorLabel, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.inputSize, inputSize = _c === void 0 ? 'normal' : _c, fluid = _a.fluid, withClear = _a.withClear, withCopy = _a.withCopy, withCounter = _a.withCounter, forCode = _a.forCode, icon = _a.icon, wrapperClass = _a.wrapperClass, onEnterKey = _a.onEnterKey, onDeleteKey = _a.onDeleteKey, onIconClick = _a.onIconClick, onChange = _a.onChange, rest = __rest(_a, ["label", "errorLabel", "type", "inputSize", "fluid", "withClear", "withCopy", "withCounter", "forCode", "icon", "wrapperClass", "onEnterKey", "onDeleteKey", "onIconClick", "onChange"]);
    var _d = useState(rest.defaultValue || ''), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(type), inputType = _e[0], setInputType = _e[1];
    var _f = useState(false), isCopied = _f[0], setIsCopied = _f[1];
    var _g = useState(typeof rest.value === 'string' ? rest.value.length : rest.value || 0), symbolsCount = _g[0], setSymbolsCount = _g[1];
    var handleInputChange = function (e) {
        setInputValue(e.target.value);
        if (withCounter) {
            var count = e.target.value.length;
            setSymbolsCount(count);
        }
        if (onChange) {
            onChange(e);
        }
    };
    var handleKeyUp = function (e) {
        if (e.key === ENTER_BTN_CODE && onEnterKey) {
            onEnterKey();
        }
        if (e.key === DELETE_BTN_CODE && onDeleteKey) {
            onDeleteKey();
        }
    };
    var handleEyeClick = function () {
        setInputType(inputType === 'password' ? 'text' : 'password');
    };
    var handleCopyClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, window.navigator.clipboard.writeText(inputValue)];
                case 1:
                    _a.sent();
                    setIsCopied(true);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement("div", { className: cn(css$j.block, forCode && css$j.code, wrapperClass) },
        label && (React__default.createElement(UiText, { className: css$j.label, as: "label", size: "small_plus" }, label)),
        React__default.createElement("div", { className: css$j.field },
            React__default.createElement("input", __assign({}, rest, { className: cn(css$j.input, css$j["input_".concat(inputSize)], fluid && css$j.fluid, errorLabel && css$j.error, withCopy && css$j.inputCopy, withClear && css$j.inputClear, isCopied && css$j.active, type === 'search' && css$j.inputSearch), type: inputType, onKeyUp: handleKeyUp, onChange: function (e) {
                    handleInputChange(e);
                }, ref: ref })),
            type === 'password' && (React__default.createElement("div", { className: cn(css$j.eye, inputType === 'text' && css$j.eyeClosed), onClick: handleEyeClick },
                React__default.createElement(UiIcon, { name: inputType === 'password' ? 'eye' : 'eye-close', width: 16, height: inputType === 'password' ? 10 : 16, color: "#d7dadf" }))),
            withClear && rest.value && (React__default.createElement("div", { className: css$j.clear },
                React__default.createElement(UiIcon, { name: "close-circle-bg", size: 16, onClick: function () {
                        onIconClick && onIconClick();
                    } }))),
            withCopy && (React__default.createElement("div", { className: css$j.copy, onClick: handleCopyClick },
                React__default.createElement(UiIcon, { name: "copy", size: 19 }))),
            icon && !withClear ? (React__default.createElement(React__default.Fragment, null, typeof icon === 'string' ? (React__default.createElement(UiIcon, { name: icon, className: css$j.icon, onClick: function () { return onIconClick && onIconClick(); } })) : (icon))) : !icon && type === 'search' ? (React__default.createElement(UiIcon, { name: "loupe", color: "#666C77", className: cn(css$j.icon, css$j.searchIcon), onClick: function () { return onIconClick && onIconClick(); } })) : null),
        React__default.createElement("div", { className: css$j.bottom },
            errorLabel && !forCode && (React__default.createElement(UiText, { size: "small", color: "danger" }, errorLabel)),
            withCounter && rest.maxLength && (React__default.createElement(UiText, { className: css$j.counter, color: "grey", size: "small_x" },
                symbolsCount,
                "/",
                rest.maxLength))),
        isCopied && (React__default.createElement(UiText, { size: "small_x", color: "blue", align: "left" }, "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"))));
};
var UiInput = forwardRef(InputComponent);

var css$i = {"wrapper":"Datepicker_wrapper__BHnVU","calendarBtn":"Datepicker_calendarBtn__YO0r4","calendarIcon":"Datepicker_calendarIcon__zKf4w","clear":"Datepicker_clear__Q6U1Y"};

registerLocale('ru', ru);
setDefaultLocale('ru');
//преобразует месяц в числовой формат или полное название месяца
var formatMonth = function (fullFormat, date) {
    if (fullFormat === void 0) { fullFormat = true; }
    return fullFormat
        ? dayjs(date).format('DD MMMM')
        : dayjs(date).format('DD.MM');
};
var UiDatepicker = function (props) {
    var withCalendarButton = props.withCalendarButton, startDate = props.startDate, endDate = props.endDate, _a = props.inputLabel, inputLabel = _a === void 0 ? '' : _a, errorLabel = props.errorLabel, fullFormatMonth = props.fullFormatMonth, customInputLabel = props.customInputLabel;
    // eslint-disable-next-line
    var CalendarBtnComponent = forwardRef(function (_a, ref) {
        var onClick = _a.onClick;
        return (React__default.createElement("div", { className: css$i.calendarBtn, ref: ref, onClick: onClick },
            React__default.createElement("span", { className: css$i.calendarIcon },
                React__default.createElement(UiIcon, { name: "calendar2", size: 18 })),
            React__default.createElement(UiText, { size: "small_plus", weight: "normal" }, startDate && !endDate
                ? formatMonth(fullFormatMonth, dayjs(startDate))
                : startDate && endDate
                    ? "".concat(formatMonth(fullFormatMonth, dayjs(startDate)), " - ").concat(formatMonth(fullFormatMonth, dayjs(endDate)))
                    : customInputLabel),
            startDate && (React__default.createElement(UiIcon, { name: "close", size: 12, className: css$i.clear, onClick: function (e) {
                    e.stopPropagation();
                    props.onChange([null, null], e);
                } }))));
    });
    // eslint-disable-next-line
    var InputComponent = forwardRef(function (_a, ref) {
        var inputLabel = _a.inputLabel, errorLabel = _a.errorLabel, disabled = _a.disabled, onClick = _a.onClick, rest = __rest(_a, ["inputLabel", "errorLabel", "disabled", "onClick"]);
        return (React__default.createElement(InputMask, __assign({ mask: "99.99.9999", disabled: disabled }, rest), function (inputProps) { return (React__default.createElement(UiInput, __assign({ label: inputLabel, errorLabel: errorLabel, disabled: disabled, icon: "calendar2", onIconClick: onClick }, inputProps))); }));
    });
    return (React__default.createElement("div", { className: css$i.wrapper }, withCalendarButton ? (React__default.createElement(DatePicker, __assign({}, props, { customInput: React__default.createElement(CalendarBtnComponent, null) }))) : (React__default.createElement(DatePicker, __assign({}, props, { customInput: React__default.createElement(InputComponent, { inputLabel: inputLabel, errorLabel: errorLabel, fluid: true }) })))));
};

var css$h = {"block":"Divider_block__S-vJl","dividerWithText":"Divider_dividerWithText__zO0uo","leftBorder":"Divider_leftBorder__psAJX","rightBorder":"Divider_rightBorder__-E-C6","text":"Divider_text__Ud63W"};

var UiDivider = function (_a) {
    var text = _a.text, _b = _a.offset, offset = _b === void 0 ? 30 : _b;
    return (React__default.createElement("div", { className: cn(css$h.block, text && css$h.dividerWithText), style: { margin: "".concat(offset, "px 0") } },
        React__default.createElement("div", { className: css$h.leftBorder }),
        text && React__default.createElement("div", { className: css$h.text }, text),
        React__default.createElement("div", { className: css$h.rightBorder })));
};

var css$g = {"block":"FilesUpload_block__YxZgH","input":"FilesUpload_input__98ikT","note":"FilesUpload_note__s8X5M","list":"FilesUpload_list__R8YhV","name":"FilesUpload_name__r0ypK","delete":"FilesUpload_delete__eCeGm"};

var UiFilesUpload = function (props) {
    var inputRef = useRef(null);
    var className = props.className, disabled = props.disabled, _a = props.variant, variant = _a === void 0 ? 'standard' : _a, note = props.note, _b = props.title, title = _b === void 0 ? 'Прикрепить файл' : _b, multiple = props.multiple, onUpload = props.onUpload;
    var handleChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = event.target.files;
                    return [4 /*yield*/, onUpload(files)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpload = function () {
        var _a;
        ((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click) && inputRef.current.click();
    };
    return (React__default.createElement("div", { className: cn(css$g.block, className) },
        React__default.createElement("input", { type: "file", multiple: multiple, ref: inputRef, className: css$g.input, disabled: disabled, onChange: handleChange }),
        React__default.createElement(UiButton, { fluid: true, variant: variant, type: "button", disabled: disabled, onClick: handleUpload }, title),
        note && (React__default.createElement(UiText, { className: css$g.note, size: "small", color: "grey" }, note))));
};

var css$f = {"wrap":"LikeBtn_wrap__8Ugjs","block":"LikeBtn_block__3V96Z","active":"LikeBtn_active__6j98V","inverted":"LikeBtn_inverted__cqJFd","label":"LikeBtn_label__k-zcy"};

// коррекция в пикселях для подгонки иконки как в дизайне
var iconCorrection = 3;
var UiLikeBtn = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, size = _a.size, label = _a.label, isActive = _a.isActive, onClick = _a.onClick;
    return (React__default.createElement("div", { className: css$f.wrap },
        React__default.createElement("button", { className: cn(css$f.block, css$f[type], isActive && css$f.active), style: { width: "".concat(size, "px"), height: "".concat(size, "px") }, onClick: function (e) {
                e.preventDefault();
                onClick(!isActive);
            }, type: "button" },
            React__default.createElement(UiIcon, { name: "like", size: size / 2 - iconCorrection })),
        label && (React__default.createElement(UiText, { className: css$f.label, weight: "normal", size: "small" }, label))));
};

var css$e = {"block":"Loader_block__-8iiQ"};

var UiLoader = function (props) {
    var children = props.children, loading = props.loading;
    return (React__default.createElement(React__default.Fragment, null, loading ? (React__default.createElement("div", { className: css$e.block },
        React__default.createElement(UiIcon, { name: "loader", size: 40, color: "#000000" }))) : (children)));
};

// https://usehooks.com/useOnClickOutside/
function useOnClickOutside(ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}

var ESC_BTN_CODE = 'Escape';
var useEscapeListener = function (isShown, onClose) {
    var keyboardListener = useCallback(function (e) {
        if (e.key === ESC_BTN_CODE && onClose) {
            onClose();
        }
    }, [onClose]);
    useEffect(function () {
        var _a;
        if (isShown) {
            document.addEventListener('keyup', keyboardListener);
            (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.add('no-scroll');
        }
        return function () {
            var _a;
            if (isShown) {
                document.removeEventListener('keyup', keyboardListener);
                (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.remove('no-scroll');
            }
        };
    }, [isShown, keyboardListener]);
};

var css$d = {"wrapper":"Modal_wrapper__65JHm","body":"Modal_body__3zIj9","bodyCentered":"Modal_bodyCentered__KpvE5","close":"Modal_close__058gy"};

var UiModal = function (_a) {
    var isShowing = _a.isShowing, children = _a.children, centered = _a.centered, onClose = _a.onClose, wrapperRef = _a.wrapperRef, bodyClass = _a.bodyClass;
    var modalBodyEl = useRef(null);
    var defaultAnimValues = {
        scale: 0.5,
    };
    if (centered) {
        defaultAnimValues.translateY = '-50%';
    }
    useOnClickOutside(modalBodyEl, function () { return onClose && onClose(); });
    //хук для закрытия по нажатию на Esc
    useEscapeListener(isShowing, onClose);
    return isShowing
        ? ReactDOM.createPortal(React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { ref: wrapperRef, className: css$d.wrapper },
                React__default.createElement(motion.div, { initial: defaultAnimValues, animate: { scale: 1 }, className: cn(css$d.body, centered && css$d.bodyCentered, bodyClass), ref: modalBodyEl },
                    React__default.createElement("button", { type: "button", className: css$d.close, onClick: onClose },
                        React__default.createElement(UiIcon, { name: "close", size: 18 })),
                    children))), document.body)
        : null;
};

var UiNotify = function (props) {
    return React__default.createElement(ToastContainer, __assign({}, props));
};
var notify = function (content, options) {
    return toast(content, options);
};

var css$c = {"block":"PinCodeInput_block__aJVof"};

var digitsPattern = /^\d+$/;
var UiPinCodeInput = function (_a) {
    var codeLength = _a.codeLength, errorLabel = _a.errorLabel, mask = _a.mask, onInputComplete = _a.onInputComplete;
    var _b = useState(Array(codeLength + 1).join(' ')), code = _b[0], setCode = _b[1];
    var inputRefs = useRef([]);
    var inputsArr = useMemo(function () {
        var arr = [];
        for (var i = 0; i < codeLength; i++) {
            arr.push(i);
        }
        return arr;
    }, [codeLength]);
    var handleChangeCode = function (e, index) {
        var currentInput = inputRefs.current[index];
        var nextInput = inputRefs.current[index + 1];
        var value = e.target.value;
        if (value) {
            if (nextInput) {
                nextInput.focus();
            }
            else {
                currentInput.blur();
            }
        }
        else {
            inputRefs.current.map(function (input, i) {
                if (index < i) {
                    input.value = '';
                }
            });
        }
    };
    var handleBlurCode = function () {
        var codesArr = [];
        inputRefs.current.map(function (input) {
            codesArr.push(input.value || ' ');
        });
        setCode(codesArr.join(''));
    };
    var handlePasteToInput = function (e, index) {
        try {
            var pastedCode = e.clipboardData.getData('text/plain');
            var segments_1 = pastedCode.split('');
            inputRefs.current.map(function (input, i) {
                input.value = segments_1[i] || '';
            });
            inputRefs.current[index].blur();
        }
        catch (err) {
            console.log(err);
        }
    };
    var handleDeleteKey = function (index) {
        var currentInput = inputRefs.current[index];
        var prevInput = inputRefs.current[index - 1];
        if (currentInput) {
            currentInput.value = '';
        }
        if (prevInput) {
            prevInput.focus();
            prevInput.value = '';
        }
    };
    var handleKeyDown = function (e) {
        if (mask === 'digits' && e.code !== 'KeyV') {
            if (!digitsPattern.test(e.key)) {
                e.preventDefault();
            }
        }
    };
    useEffect(function () {
        var codesArr = code.split('');
        var emptyItems = codesArr.filter(function (c) { return c === ' '; });
        if (emptyItems.length === 0) {
            onInputComplete(code);
        }
    }, [code]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: css$c.block }, inputsArr.map(function (index) { return (React__default.createElement(UiInput, { id: "pinCode_input_".concat(index), key: "pinCode_input_field_".concat(index), ref: function (input) {
                if (input) {
                    inputRefs.current[index] = input;
                }
            }, autoFocus: index === 0, forCode: true, maxLength: 1, errorLabel: errorLabel, onKeyDown: handleKeyDown, onChange: function (e) {
                handleChangeCode(e, index);
            }, onBlur: handleBlurCode, onPaste: function (e) {
                handlePasteToInput(e, index);
            }, onDeleteKey: function () {
                handleDeleteKey(index);
            }, autoComplete: index === 0 ? 'one-time-code' : undefined, inputMode: mask === 'digits' ? 'numeric' : 'text' })); })),
        errorLabel && (React__default.createElement(UiText, { size: "small", color: "danger" }, errorLabel))));
};

var css$b = {"block":"Progress_block__KF0kw","indicator":"Progress_indicator__Wxii9"};

var UiProgress = function (props) {
    var _a = props.size, size = _a === void 0 ? 5 : _a, _b = props.percent, percent = _b === void 0 ? 0 : _b, _c = props.color, color = _c === void 0 ? '#cccccc' : _c, _d = props.bgColor, bgColor = _d === void 0 ? '#ffffff' : _d;
    return (React__default.createElement("div", { className: css$b.block, style: { height: "".concat(size, "px"), backgroundColor: bgColor } },
        React__default.createElement("div", { className: css$b.indicator, style: { width: "".concat(percent, "%"), backgroundColor: color } })));
};

var css$a = {"block":"Rating_block__MB3QU","item":"Rating_item__smm2T","active":"Rating_active__AhrgZ","icon":"Rating_icon__dwHe6","selected":"Rating_selected__t2HU-"};

var UiRating = function (_a) {
    var stars = _a.stars, onSelect = _a.onSelect;
    var _b = useState(0), selectedItem = _b[0], setSelectedItem = _b[1];
    var _c = useState(0), activeItem = _c[0], setActiveItem = _c[1];
    var starsArr = useMemo(function () {
        var arr = [];
        for (var i = 0; i < stars; i++) {
            arr.push(i + 1);
        }
        return arr;
    }, [stars]);
    var handleItemClick = function (index) {
        setSelectedItem(index);
        onSelect(index);
    };
    return (React__default.createElement("div", { className: css$a.block }, starsArr.map(function (s) { return (React__default.createElement("div", { key: s, className: cn(css$a.item, (s <= activeItem || s <= selectedItem) && css$a.active, s === selectedItem && css$a.selected), onMouseOver: function () {
            setActiveItem(s);
        }, onMouseLeave: function () {
            setActiveItem(0);
        }, onClick: function () {
            handleItemClick(s);
        } },
        React__default.createElement(UiIcon, { name: "star", className: css$a.icon }))); })));
};

var UiScrollbar = function (_a) {
    var children = _a.children, options = _a.options, rest = __rest(_a, ["children", "options"]);
    return (React__default.createElement(SimpleBar, __assign({}, options, rest), children));
};

var css$9 = {"wrapper":"CustomMarkOption_wrapper__DNMFu","option":"CustomMarkOption_option__YmRwS"};

function CustomMarkOption(props) {
    var innerProps = props.innerProps, innerRef = props.innerRef, isSelected = props.isSelected, isDisabled = props.isDisabled, isMulti = props.isMulti, selectOption = props.selectOption;
    innerProps.onClick = function () { return selectOption(props.data); };
    return (React__default.createElement("div", __assign({ ref: innerRef }, innerProps, { className: css$9.wrapper }),
        React__default.createElement("div", { className: css$9.option },
            React__default.createElement(UiCheckbox, { type: isMulti ? 'checkbox' : 'radio', onChange: function (e) { return e.preventDefault(); }, checked: isSelected, label: props.data.label, disabled: isDisabled }))));
}

var css$8 = {"wrapper":"CustomMultiValue_wrapper__rBhOe","value":"CustomMultiValue_value__sBwYl","count":"CustomMultiValue_count__Z6Fpq"};

function CustomMultiValue(_a) {
    var _b = _a.selectedOptions, selectedOptions = _b === void 0 ? [] : _b;
    return (React__default.createElement("div", { className: css$8.wrapper },
        React__default.createElement("div", { className: css$8.value }, selectedOptions.reduce(function (acc, item) {
            return (acc +=
                selectedOptions.length <= 1 ? item.label : "".concat(item.label, ", "));
        }, '')),
        selectedOptions.length > 0 && (React__default.createElement("div", { className: css$8.count },
            "(",
            selectedOptions.length,
            ")"))));
}

var css$7 = {"block":"Select_block__1AdQi","label":"Select_label__zUgZC","innerMultiValue":"Select_innerMultiValue__KGZGb","showSelectedCount":"Select_showSelectedCount__KpEdd","scrollWrapper":"Select_scrollWrapper__ua5va"};

var getBorderColor = function (isError, isFocused, isDisabled) {
    if (isError) {
        return '#ED694AFF';
    }
    if (isFocused) {
        return '#426fff';
    }
    if (isDisabled) {
        return 'transparent';
    }
    return '#AFC1D9';
};
var selectStyles = function (isError) { return ({
    container: function (rules) { return (__assign({}, rules)); },
    control: function (rules, _a) {
        var isFocused = _a.isFocused, isDisabled = _a.isDisabled;
        return (__assign(__assign({}, rules), { padding: '0 10px 0 20px', height: '58px', borderRadius: '12px', backgroundColor: isDisabled ? '#eaecef' : '#f5f6f7', borderColor: getBorderColor(isError, isFocused, isDisabled), boxShadow: 'none', fontSize: '14px', color: '#181818', cursor: 'pointer', '&:hover': {
                borderColor: getBorderColor(isError, isFocused, isDisabled),
            } }));
    },
    placeholder: function (rules) { return (__assign(__assign({}, rules), { color: '#666C77', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' })); },
    valueContainer: function (rules) { return (__assign(__assign({}, rules), { width: 'max-content', height: '20px', flexDirection: 'column', alignItems: 'flex-start', padding: 0, fontWeight: 300 })); },
    singleValue: function (rules, _a) {
        var isDisabled = _a.isDisabled;
        return (__assign(__assign({}, rules), { color: isDisabled ? '#afb9cc' : '#666C77' }));
    },
    multiValue: function (rules) { return (__assign(__assign({}, rules), { maxWidth: '95%', backgroundColor: 'inherit' })); },
    indicatorsContainer: function (rules) { return (__assign({}, rules)); },
    indicatorSeparator: function () { return ({}); },
    dropdownIndicator: function (rules) { return (__assign(__assign({}, rules), { color: '#666C77' })); },
    menu: function (rules) { return (__assign(__assign({}, rules), { fontSize: '16px', fontWeight: '300', color: '#222222', background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF)', boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.15)', borderRadius: '12px', borderColor: 'transparent', zIndex: 1000 })); },
    menuList: function (rules) { return (__assign(__assign({}, rules), { background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF)', borderRadius: '12px' })); },
    option: function (rules, _a) {
        var isFocused = _a.isFocused;
        return (__assign(__assign({}, rules), { padding: '12px', color: '#222222', fontSize: '16px', backgroundColor: isFocused ? '#f5f6f7' : 'none', cursor: 'pointer' }));
    },
}); };
var UiSelect = function (props) {
    var async = props.async, label = props.label, errorLabel = props.errorLabel, isCustomOption = props.isCustomOption, showSelectedCount = props.showSelectedCount;
    var DropdownIndicator = function (props) {
        return (React__default.createElement(components.DropdownIndicator, __assign({}, props),
            React__default.createElement(UiIcon, { name: "arrow-profile", width: 10, height: 7 })));
    };
    var MultiValue = function (_a) {
        _a.children; var props = __rest(_a, ["children"]);
        return (React__default.createElement("div", { className: cn(css$7.innerMultiValue, showSelectedCount && css$7.showSelectedCount) },
            React__default.createElement(CustomMultiValue, { selectedOptions: props.selectProps.value })));
    };
    var Scrollbar = function (props) {
        return (React__default.createElement(UiScrollbar, { className: css$7.scrollWrapper }, props.children));
    };
    var customComponents = {
        DropdownIndicator: DropdownIndicator,
        Option: isCustomOption ? CustomMarkOption : components.Option,
        MultiValueRemove: function () { return null; },
        MultiValue: showSelectedCount ? MultiValue : components.MultiValue,
        MenuList: Scrollbar,
    };
    var selectComponent = async ? (React__default.createElement(AsyncSelect, __assign({}, props, { components: customComponents, styles: selectStyles(Boolean(errorLabel)) }))) : (React__default.createElement(Select, __assign({}, props, { components: customComponents, styles: selectStyles(Boolean(errorLabel)) })));
    return (React__default.createElement("div", { className: css$7.block },
        label && (React__default.createElement(UiText, { className: css$7.label, as: "label", size: "small_plus" }, label)),
        selectComponent,
        errorLabel && (React__default.createElement(UiText, { size: "small", color: "danger" }, errorLabel))));
};

var css$6 = {"block":"Slider_block__AAzSi","prevArrow":"Slider_prevArrow__lzZeN","nextArrow":"Slider_nextArrow__vPHES"};

var firstClientX, clientX;
var SliderComponent = function (props, ref) {
    var className = props.className, children = props.children;
    var containerRef = useRef(null);
    var preventTouch = function (e) {
        var minValue = 5; // threshold
        clientX = e.touches[0].clientX - firstClientX;
        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(clientX) > minValue) {
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    };
    var touchStart = function (e) {
        firstClientX = e.touches[0].clientX;
    };
    useEffect(function () {
        if (containerRef.current) {
            containerRef.current.addEventListener('touchstart', touchStart);
            containerRef.current.addEventListener('touchmove', preventTouch, {
                passive: false,
            });
        }
        return function () {
            if (containerRef.current) {
                containerRef.current.removeEventListener('touchstart', touchStart);
                containerRef.current.removeEventListener('touchmove', preventTouch, {
                    passive: false,
                });
            }
        };
    }, []);
    return (React__default.createElement("div", { ref: containerRef },
        React__default.createElement(Slider, __assign({}, props, { ref: ref, className: cn(className, css$6.block) }), children)));
};
var NextArrow = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, customClass = _a.customClass, style = _a.style, onClick = _a.onClick;
    var cn = className.split(' ').filter(function (i) { return i.includes('disabled'); });
    return (React__default.createElement("button", { type: "button", className: "".concat(cn, " ").concat(css$6.nextArrow, " ").concat(customClass), style: __assign({}, style), onClick: onClick },
        React__default.createElement(UiIcon, { name: "arrow-button" })));
};
var PrevArrow = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, customClass = _a.customClass, style = _a.style, onClick = _a.onClick;
    var cn = className.split(' ').filter(function (i) { return i.includes('disabled'); });
    return (React__default.createElement("button", { type: "button", className: "".concat(cn, " ").concat(css$6.prevArrow, " ").concat(customClass), style: __assign({}, style), onClick: onClick },
        React__default.createElement(UiIcon, { name: "arrow-button" })));
};
var Dots = function (dots) {
    return (React__default.createElement("div", null,
        React__default.createElement("ul", null, dots.map(function (item, index) { return (React__default.createElement("li", { key: "slider-dot-".concat(index), className: item.props.className }, item.props.children)); }))));
};
var UiSlider = forwardRef(SliderComponent);
UiSlider.NextArrow = NextArrow;
UiSlider.PrevArrow = PrevArrow;
UiSlider.Dots = Dots;

var css$5 = {"block":"Spacer_block__qC2kt","xs":"Spacer_xs__xBFZE","s":"Spacer_s__nr8rK","m":"Spacer_m__eWTJy","l":"Spacer_l__KdtgA","xl":"Spacer_xl__Oy6uo","xxl":"Spacer_xxl__ctOr9"};

var UiSpacer = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b;
    return React__default.createElement("div", { className: cn(css$5.block, size && css$5[size]) });
};

var css$4 = {"container":"Tabs_container__u3BX5","slashes":"Tabs_slashes__cMiYT","wrapper":"Tabs_wrapper__N4-3H","slashes_big":"Tabs_slashes_big__YH7Fv","tabs":"Tabs_tabs__z-Cun","tab":"Tabs_tab__LYqhc","buttons":"Tabs_buttons__OV2kq","tabsCentered":"Tabs_tabsCentered__mhVzu","active":"Tabs_active__LGOzg","tabBtn":"Tabs_tabBtn__IhgLj","content":"Tabs_content__SZNfw"};

var UiTabs = function (props) {
    var _a, _b;
    var children = props.children, _c = props.type, type = _c === void 0 ? 'primary' : _c, centered = props.centered, defaultActiveTabKey = props.defaultActiveTabKey, tabsWrapperClassName = props.tabsWrapperClassName, tabsClassName = props.tabsClassName, tabsContentClassName = props.tabsContentClassName, activeTabKey = props.activeTabKey, onChangeTab = props.onChangeTab;
    var _d = useState(defaultActiveTabKey || activeTabKey || children[0].props.tabKey), activeKey = _d[0], setActiveKey = _d[1];
    var currentTabContent = ((_b = (_a = children.find(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.tabKey) === activeKey; })) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) || null;
    var handleTabClick = function (tab) {
        setActiveKey(tab.tabKey);
        if (onChangeTab) {
            onChangeTab(tab);
        }
    };
    useEffect(function () {
        if (activeTabKey) {
            setActiveKey(activeTabKey);
        }
    }, [activeTabKey]);
    return (React__default.createElement("div", { className: cn(css$4.container, css$4[type], tabsWrapperClassName) },
        React__default.createElement("div", { className: cn(css$4.wrapper, tabsClassName) },
            React__default.createElement("div", { className: cn(css$4.tabs, centered && css$4.tabsCentered) }, children.map(function (item) {
                if (!item)
                    return;
                var tab = item.props;
                if (type === 'buttons') {
                    return (React__default.createElement(UiButton, { className: css$4.tabBtn, onClick: function () { return handleTabClick(tab); }, size: "small", variant: activeKey === tab.tabKey ? 'primary' : 'outline', key: "ui_tab_".concat(tab.tabKey) }, tab.tabLabel));
                }
                return (React__default.createElement("button", { key: "ui_tab_".concat(tab.tabKey), type: "button", className: cn(css$4.tab, activeKey === tab.tabKey && css$4.active), onClick: function () {
                        handleTabClick(tab);
                    } }, tab.tabLabel));
            }))),
        React__default.createElement("div", { className: cn(css$4.content, tabsContentClassName) }, currentTabContent)));
};
var UiTab = function (props) {
    return React__default.createElement(React__default.Fragment, null);
};

var css$3 = {"wrapper":"Tags_wrapper__QGz5f","list":"Tags_list__oLge8","listItem":"Tags_listItem__0AStP","active":"Tags_active__vXevv"};

var UiTags = function (props) {
    var tags = props.tags, selected = props.selected, multiple = props.multiple, onTagClick = props.onTagClick, className = props.className;
    var _a = useState(multiple ? [] : ''), selectedTags = _a[0], setSelectedTags = _a[1];
    var isSelectedTag = function (tag) {
        return multiple ? selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(tag.value) : selectedTags === tag.value;
    };
    var handleTagClick = function (tag) {
        var newTags;
        if (multiple) {
            if (typeof selectedTags === 'object' &&
                selectedTags.includes(tag.value)) {
                newTags = selectedTags.filter(function (t) { return t !== tag.value; });
            }
            else {
                newTags = [tag.value].concat(selectedTags);
            }
        }
        else {
            newTags = tag.value;
        }
        setSelectedTags(newTags);
        if (onTagClick) {
            onTagClick(newTags);
        }
    };
    useEffect(function () {
        if (selected) {
            setSelectedTags(selected);
        }
    }, [selected]);
    return (React__default.createElement("div", { className: css$3.wrapper },
        React__default.createElement("ul", { className: cn(css$3.list, className) }, tags.map(function (tag, index) { return (React__default.createElement("li", { className: cn(css$3.listItem, isSelectedTag(tag) && css$3.active), key: index, onClick: function () { return handleTagClick(tag); } }, tag.label)); }))));
};

var css$2 = {"block":"Textarea_block__w8lY5","label":"Textarea_label__EjFTD","field":"Textarea_field__AVLZm","icon":"Textarea_icon__qO778","textarea":"Textarea_textarea__yE6jp","error":"Textarea_error__ZaNn-","autoHeight":"Textarea_autoHeight__RwzhE","fluid":"Textarea_fluid__pH9zn","bottom":"Textarea_bottom__X1Nqu","counter":"Textarea_counter__-Q123"};

var UiTextArea = function (props) {
    var label = props.label, fluid = props.fluid, errorLabel = props.errorLabel, withCounter = props.withCounter, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, autoHeight = props.autoHeight, _a = props.maxAutoHeight, maxAutoHeight = _a === void 0 ? 300 : _a, _b = props.rows, rows = _b === void 0 ? 5 : _b, rest = __rest(props, ["label", "fluid", "errorLabel", "withCounter", "onBlur", "onFocus", "onChange", "value", "autoHeight", "maxAutoHeight", "rows"]);
    var ref = createRef();
    var _c = useState(value ? value.length : 0), symbolsCount = _c[0], setSymbolsCount = _c[1];
    var updateCounter = function (value) {
        var count;
        withCounter && value ? (count = value.length) : (count = 0);
        setSymbolsCount(count);
    };
    var resizeByScrollHeight = function () {
        if (ref && ref.current) {
            ref.current.style.height = 'auto';
            var scrollHeight = ref.current.scrollHeight;
            if (scrollHeight >= maxAutoHeight) {
                ref.current.style.height = "".concat(maxAutoHeight, "px");
                ref.current.style.overflow = 'auto';
            }
            else {
                ref.current.style.height = "".concat(scrollHeight, "px");
                ref.current.style.overflow = 'hidden';
            }
        }
    };
    var handleChangeTextArea = function (e) {
        updateCounter(e.target.value);
        if (onChange)
            onChange(e);
        if (autoHeight)
            resizeByScrollHeight();
    };
    var handleFocusEvent = function (e) {
        e.target.value = e.target.value.trim();
        updateCounter(e.target.value);
        if (onFocus)
            onFocus(e);
    };
    var handleBlurEvent = function (e) {
        e.target.value = e.target.value.trim();
        updateCounter(e.target.value);
        if (onBlur)
            onBlur(e);
    };
    //Обновляем состояние счетчика, если срабатывает onBlur или onFocus и вызывается trim()
    useEffect(function () {
        updateCounter(value);
    }, [value]);
    return (React__default.createElement("div", { className: css$2.block },
        label && (React__default.createElement(UiText, { className: css$2.label, as: "label", size: "small_plus" }, label)),
        React__default.createElement("div", { className: css$2.field },
            React__default.createElement("textarea", __assign({}, rest, { rows: rows, className: cn(css$2.textarea, fluid && css$2.fluid, errorLabel && css$2.error, autoHeight && css$2.autoHeight), value: value, onChange: handleChangeTextArea, onBlur: handleBlurEvent, onFocus: handleFocusEvent, ref: ref }))),
        React__default.createElement("div", { className: css$2.bottom },
            errorLabel && (React__default.createElement(UiText, { size: "small", color: "danger" }, errorLabel)),
            withCounter && rest.maxLength && (React__default.createElement(UiText, { className: css$2.counter, color: "grey", align: "right", size: "small_x" },
                symbolsCount,
                "/",
                rest.maxLength)))));
};

var css$1 = {"block":"Title_block__IDuna","massive":"Title_massive__V66Dg","huge":"Title_huge__nHXTz","big":"Title_big__yNrHI","large":"Title_large__nsCxE","medium":"Title_medium__kgxzN","small":"Title_small__shIXM","tiny":"Title_tiny__7SObF","left":"Title_left__Tdda9","center":"Title_center__-l2z-","right":"Title_right__2pnDE","weightNormal":"Title_weightNormal__EN5Ym","weightMedium":"Title_weightMedium__HCKEl","weightBold":"Title_weightBold__--lEI","white":"Title_white__T-YKP"};

var UiTitle = function (props) {
    var as = props.as, _a = props.size, size = _a === void 0 ? 'large' : _a, _b = props.align, align = _b === void 0 ? 'left' : _b, _c = props.weight, weight = _c === void 0 ? 'normal' : _c, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.color, color = _e === void 0 ? 'default' : _e, children = props.children;
    var ElementType = getElementType(UiTitle, props);
    var classes = cn(css$1.block, as && css$1[as], size && css$1[size], align && css$1[align], weight &&
        css$1["weight".concat(weight[0].toUpperCase() + weight.slice(1))], color && css$1[color], className);
    return React__default.createElement(ElementType, { className: classes }, children);
};

var UiTooltip = function (_a) {
    var content = _a.content, onMount = _a.onMount, onHidden = _a.onHidden, props = __rest(_a, ["content", "onMount", "onHidden"]);
    var _b = props.theme, theme = _b === void 0 ? 'light' : _b;
    var _c = useState(false), mounted = _c[0], setMounted = _c[1];
    var mountHandler = function (instance) {
        setMounted(true);
        if (onMount) {
            onMount(instance);
        }
    };
    var unmountHandler = function (instance) {
        setMounted(false);
        if (onHidden) {
            onHidden(instance);
        }
    };
    return (React__default.createElement(Tippy, __assign({ theme: theme }, props, { onMount: mountHandler, onHidden: unmountHandler, content: mounted ? content : null }), props.children));
};

var UiMaskInput = function (props) {
    return (React__default.createElement(InputMask, __assign({}, props.maskInputProps), function (inputProps) { return (React__default.createElement(UiInput, __assign({}, inputProps, props.inputProps, { type: "tel" }))); }));
};

var css = {"block":"PhoneInput_block__iC0ap","selectBtn":"PhoneInput_selectBtn__WMExR","selectBtnDisabled":"PhoneInput_selectBtnDisabled__MMfUs","inputWrapper":"PhoneInput_inputWrapper__sy2Wf","inputPadding":"PhoneInput_inputPadding__iu1jH","popup":"PhoneInput_popup__2l-i2","popupOffset":"PhoneInput_popupOffset__1zdk5","list":"PhoneInput_list__4MGaU"};

var REGION_CODES = [
    {
        code: '+7',
        mask: '+7 (\\999) 999-99-99',
        placeholder: '(___) ___-__-__',
        label: 'Российская Федерация',
    },
    {
        code: '+380',
        mask: '+380 (7c\\) 999-99-99',
        placeholder: '(__) ___-__-__',
        label: 'ДНР/ЛНР',
    },
    {
        code: '+380',
        mask: '+380 (61) 999-99-99',
        placeholder: '(__) ___-__-__',
        label: 'Запорожье',
    },
];
var UiPhoneInput = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = props.inputProps || {}; _g.value; _g.onChange; _g.onBlur; var restInputProps = __rest(_g, ["value", "onChange", "onBlur"]);
    var _h = useState(REGION_CODES[0]), selectedRegion = _h[0], setSelectedRegion = _h[1];
    var _j = useState(false), popupOpened = _j[0], setPopupOpened = _j[1];
    var phoneInputEl = useRef(null);
    useOnClickOutside(phoneInputEl, function () { return setPopupOpened(false); });
    var regionsForPopup = useMemo(function () { return REGION_CODES.filter(function (region) { return region.mask !== (selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.mask); }); }, [selectedRegion]);
    var handleSelectBtnCLick = function (e) {
        var _a;
        e.stopPropagation();
        if ((_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.disabled)
            return;
        setPopupOpened(!popupOpened);
    };
    var handleRegionSelect = function (region) {
        setSelectedRegion(region);
        setPopupOpened(false);
        if (props.onChangeCode) {
            props.onChangeCode(region);
        }
    };
    useEffect(function () {
        var _a;
        var value = (_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.value;
        if (value) {
            REGION_CODES.map(function (region) {
                if (value.startsWith(region.code)) {
                    setSelectedRegion(region);
                }
            });
        }
    }, []);
    return (React__default.createElement("div", { className: css.block, ref: phoneInputEl },
        React__default.createElement("div", { className: css.inputWrapper },
            React__default.createElement(UiMaskInput, { maskInputProps: {
                    mask: (selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.mask) || '',
                    formatChars: { '9': '[0-9]', c: '[1-2]' },
                    alwaysShowMask: true,
                    value: (_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.value,
                    onChange: (_b = props.inputProps) === null || _b === void 0 ? void 0 : _b.onChange,
                    onBlur: (_c = props.inputProps) === null || _c === void 0 ? void 0 : _c.onBlur,
                    disabled: (_d = props.inputProps) === null || _d === void 0 ? void 0 : _d.disabled,
                }, inputProps: __assign({ fluid: true, placeholder: selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.placeholder, wrapperClass: css.inputPadding, icon: (React__default.createElement("div", { className: cn(css.selectBtn, ((_e = props.inputProps) === null || _e === void 0 ? void 0 : _e.disabled) && css.selectBtnDisabled), onClick: handleSelectBtnCLick },
                        React__default.createElement(UiIcon, { name: popupOpened ? 'arrow-accordion-up' : 'arrow-accordion', size: 12 }))) }, restInputProps) })),
        popupOpened && (React__default.createElement("div", { className: cn(css.popup, ((_f = props.inputProps) === null || _f === void 0 ? void 0 : _f.errorLabel) && css.popupOffset) },
            React__default.createElement("ul", { className: css.list }, regionsForPopup.map(function (item, i) { return (React__default.createElement("li", { key: "region_".concat(i), onClick: function () { return handleRegionSelect(item); } },
                React__default.createElement("span", null, item.code),
                item.label)); }))))));
};

export { UiAccordion, UiBreadcrumbs, UiButton, UiCheckbox, UiDatepicker, UiDivider, UiFilesUpload, UiIcon, UiInput, UiLikeBtn, UiLoader, UiMaskInput, UiModal, UiNotify, UiPhoneInput, UiPinCodeInput, UiProgress, UiRating, UiScrollbar, UiSelect, UiSlider, UiSpacer, UiTab, UiTabs, UiTags, UiText, UiTextArea as UiTextarea, UiTitle, UiTooltip, notify };
//# sourceMappingURL=index.esm.js.map
